// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:34:03.407Z
// Property: Watercress Apartments (ID: 6767906449166551)
// Collections: 26 amenities, 6 floorplans (live), 41 photos, 71 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166551",
  "property_external_id": "564759",
  "property_zillow_url": "https://www.zillow.com/apartments/maize-ks/watercress-apartments/Cgyv7x/",
  "property_apartments_url": "https://www.apartments.com/watercress-apartments-maize-ks/dgtftpk/",
  "property_google_business_url": "https://www.google.com/maps/place/Watercress+Apartments/data=!4m2!3m1!1s0x0:0x4f59b1cb539e73d7?sa=X&ved=2ahUKEwj0sOLmhL2SAxVR0PACHa5SL2IQ_BJ6BAgMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47176468377",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "watercress-apartments",
  "property_name": "Watercress Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ks/maize/watercress/",
  "property_domain": null,
  "property_address": "4060 Reed Ave.",
  "property_full_address": "4060 Reed Ave., Maize, KS, 67101",
  "property_address_1": "4060 Reed Ave.",
  "property_address_2": null,
  "property_address_city": "Maize",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67101",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "Northwest Wichita",
  "property_address_latitude": "37.7576",
  "property_address_longitude": "-97.46",
  "property_email": "watercress@caseusa.com",
  "property_phone": "(316) 618-7429",
  "property_call_tracking_phone": "855-643-1621",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Watercress in Maize, KS, modern living meets community charm. Choose from spacious one to three-bedroom apartments featuring island kitchens, hardwood floors, and balconies. Enjoy amenities like a pool, fitness center, and dog park—all within a tranquil, controlled-access environment. Join us and embrace a lifestyle you'll love! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Watercress, your dream apartment community nestled in the charming locale of Maize, KS. Discover a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options, ensuring there's a perfect fit for everyone. At Watercress, we believe in enhancing your lifestyle with an exceptional array of amenities. Dive into relaxation at our sparkling pool, stay active in our state-of-the-art fitness center, or let your children unleash their energy at the playground.\n\nOur welcoming clubhouse is the hub of community life, where you can engage in planned social activities or simply unwind with neighbors. With controlled access and 24-hour maintenance on-site, you’ll feel secure and well cared for. Enjoy conveniences like door-to-door trash pickup, online services, and high-speed internet access. Plus, our pet-friendly environment features a dedicated dog park and pet play area, ensuring your furry friends feel right at home!\n\nStep inside your new apartment and be greeted by stunning finishes such as granite countertops, hardwood floors, and spacious walk-in closets. Many units also feature balconies, patios, or decks perfect for enjoying the beautiful views of our landscaped grounds. Immerse yourself in our active lifestyle with walking and biking trails, a basketball court, and a multi-use room for gatherings.\n\nReady to find your new home? Browse our availability or schedule a tour to visit Watercress today – your new community awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fb44f-b0f5-72e2-ab31-4a43f4632f89.webp",
  "property_featured_image_media": {
    "alt_text": "Watercress apartment building exterior with a tower and arched windows.",
    "public_id": "019fb44f-b0f5-72e2-ab31-4a43f4632f89",
    "storage_key": "property/6767906449166551/019fb44f-b0f5-72e2-ab31-4a43f4632f89.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "268",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "200",
  "property_pet_restrictions": "Maximum of 2 pets per unit. No weight or breed restrictions.",
  "property_pet_policy_description": "Cats and dogs are welcome. Pet fee: equal to half a month’s rent (non‑refundable). Monthly pet rent: $30 per pet. Maximum of 2 pets per unit. No weight or breed restrictions; maximum weight per pet: 200 lb.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://watercressapartmentswichita.securecafe.com/onlineleasing/watercress-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://watercressapartmentswichita.securecafe.com/residentservices/watercress-apartments/userlogin.aspx",
  "property_apply_now_url": "https://watercressapartmentswichita.securecafe.com/onlineleasing/watercress-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-11e8-734e-b4ea-c8fc4e205e2d.webp",
  "property_primary_logo_media": {
    "alt_text": "Watercress Apartment Homes logo.",
    "public_id": "019cfb50-11e8-734e-b4ea-c8fc4e205e2d",
    "storage_key": "property/6767906449166551/019cfb50-11e8-734e-b4ea-c8fc4e205e2d.webp",
    "width": 2560,
    "height": 1033
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-c122-73df-b435-74c31572d19f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Greystar logo",
    "public_id": "019cfb50-c122-73df-b435-74c31572d19f",
    "storage_key": "property/6767906449166551/019cfb50-c122-73df-b435-74c31572d19f.webp",
    "width": 325,
    "height": 122
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-11e8-734e-b4ea-c8fc4e205e2d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Watercress Apartment Homes logo.",
    "public_id": "019cfb50-11e8-734e-b4ea-c8fc4e205e2d",
    "storage_key": "property/6767906449166551/019cfb50-11e8-734e-b4ea-c8fc4e205e2d.webp",
    "width": 2560,
    "height": 1033
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-de46-72e8-ad6d-73dc6d002b71.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Watercress Apartment Homes logo.",
    "public_id": "019cfb50-de46-72e8-ad6d-73dc6d002b71",
    "storage_key": "property/6767906449166551/019cfb50-de46-72e8-ad6d-73dc6d002b71.webp",
    "width": 640,
    "height": 258
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#005697",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1267",
  "property_sqft_min": "789",
  "property_sqft_max": "1267",
  "property_price_range": "1089 - 1589",
  "property_price_min": "1089",
  "property_price_max": "1589",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/WatercressAptsKS/photos/d41d8cd9/1436278415174036/",
  "property_instagram_url": "https://www.instagram.com/watercressaptswichita/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJXeC1tmwgu4cR13OeU8uxWU8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Maize%2C+KS+67101",
  "property_tiktok_url": "https://www.tiktok.com/@watercress_apartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Watercress",
  "property_home_romance_title": "Experience Comfort and Joy in Your New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Watercress in Maize, KS, where every detail of life is elevated. From stylish one to three-bedroom apartments featuring granite countertops and walk-in closets, to a vibrant community brimming with a pool, fitness center, and dog park, your perfect home awaits. Enjoy modern living with a splash of fun!",
  "property_home_floorplans_blurb": "Welcome to Watercress in picturesque Maize, KS, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom apartments cater to your lifestyle needs. With spacious layouts and modern amenities, each home is yours to personalize. Dive into our selection and find the perfect space to call your own!",
  "property_home_gallery_blurb": "At Watercress in Maize, KS, your ideal home awaits! With spacious one, two, and three-bedroom floor plans and top-notch amenities like a refreshing pool, fitness center, and serene walking trails, each day is an experience. Envision the vibrant lifestyle that complements your every moment—let's make it a reality!",
  "property_home_neighborhood_blurb": "Welcome to Watercress in Maize, KS, where vibrant living meets community charm. Nestled near serene parks, the Sedgwick County Zoo, and the Wichita Public Library - Westlink Branch, you'll find a balance of leisure and convenience. Experience a lifestyle enriched by local favorites and endless adventure right outside your door.",
  "property_home_reviews_blurb": "At Watercress Apartments in Maize, KS, residents wholeheartedly express their love for our welcoming community. “The staff is awesome and always ready to assist,” reflects our residents, capturing the essence of our exceptional service. With beautifully maintained grounds and a host of amenities, it truly feels like home!",
  "property_neighborhood_blurb": "Nestled in Maize, KS, Watercress offers more than just modern apartment living—it's a gateway to vibrant community life. With easy access to the Wichita Public Library, Sedgwick County Zoo, and the thrilling Urban Air Trampoline Park, enjoy a wealth of nearby attractions. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Watercress in Maize, KS, your ideal home awaits! Choose from spacious one to three-bedroom floor plans that blend style and comfort. Enjoy a vibrant lifestyle with amenities like a refreshing pool, fitness center, and dog park. Elevate your living experience—where convenience meets community. Embrace the life you deserve!",
  "property_applynow_blurb": "At Watercress in Maize, KS, your perfect home awaits! Choose from stylish one-, two-, or three-bedroom floor plans that cater to every lifestyle. Enjoy refreshing pool days, fun in the playground, or relaxing moments on your private balcony. Lease online today and dive into a vibrant community brimming with amenities!",
  "property_contactus_blurb": "Welcome to Watercress, where comfort meets style in Maize, KS! Our thoughtfully designed floor plans include cozy one-bedroom retreats, spacious two-bedroom homes, and family-friendly three-bedroom layouts. Each space reflects modern living at its finest. Curious? Reach out to our leasing team with your questions today!",
  "property_faqs_blurb": "At Watercress in Maize, KS, we offer a variety of thoughtfully designed floor plans—choose from one, two, or three-bedroom apartments tailored to your lifestyle. Curious about our community? Visit our FAQs page for insights on amenities, leasing, and more to make your living experience seamless and enjoyable.",
  "property_floorplans_blurb": "At Watercress in Maize, KS, your ideal space awaits! Whether you’re seeking a cozy one-bedroom or a spacious three-bedroom, our thoughtfully designed floor plans cater to every lifestyle. Take a moment to browse our available apartment homes and find the perfect fit for your unique living experience.",
  "property_gallery_blurb": "At Watercress in Maize, KS, vibrant community life meets modern comfort. Featuring stunning one, two, and three-bedroom floor plans, our elegant amenities—from a sparkling pool and fitness center to serene walking trails—create the perfect backdrop. Picture yourself here and let the lifestyle unfold!",
  "property_interactivemap_blurb": "At Watercress in Maize, KS, choose from a variety of spacious floor plans—from cozy one-bedrooms to ample three-bedrooms. Enjoy community amenities like a sparkling pool, fitness center, and dog park, all within beautifully landscaped grounds. Use our interactive map to find the perfect apartment that fits your lifestyle!",
  "property_pets_blurb": "At Watercress in Maize, KS, your furry friends can feel right at home! With no weight or breed restrictions, bring your beloved pets along to enjoy spacious living in a vibrant community. Embrace the ease of pet-friendly amenities and a welcoming environment that celebrates every member of your family.",
  "property_referafriend_blurb": "At Watercress in Maize, KS, we embrace the spirit of community, where great friends become great neighbors. Choose from our thoughtfully designed one-, two-, or three-bedroom floor plans and experience a vibrant lifestyle. Share the joy—refer a friend today and make lasting memories together at Watercress!",
  "property_residentaccess_blurb": "Welcome to Watercress in Maize, KS, where your perfect home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Ready to streamline your living experience? Access our resident portal to pay rent, schedule maintenance, and unlock a world of convenience tailored just for you!",
  "property_reviews_blurb": "At Watercress in Maize, KS, our residents rave about the welcoming atmosphere and exceptional staff. “Simply put: I just love residing here,” shares one happy resident. With beautiful surroundings, top-notch amenities, and a strong sense of community, you’ll find everything you need to feel right at home.",
  "property_created_at": "1759851570764",
  "property_scheduletour_blurb": "At Watercress in Maize, KS, choose from spacious one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Immerse yourself in our vibrant community and see firsthand why residents love calling Watercress home. Ready to experience it all? Schedule a tour today and hear their stories!",
  "property_thankyou_blurb": "Thank you for reaching out to Watercress in Maize, KS! Our diverse floor plans, from cozy one-bedrooms to spacious three-bedrooms, provide the perfect backdrop for your lifestyle. A team member will connect with you soon to help you find your ideal home. Stay tuned for all the exciting details!",
  "property_virtualtours_blurb": "Welcome to Watercress in Maize, KS, where comfort meets style! Choose from thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Experience our vibrant community and stunning apartments—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Watercress",
  "property_seo_title_home": "Watercress |  Apartments in Maize, KS",
  "property_seo_description_home": "Experience life at Watercress in Maize, KS! Enjoy modern amenities, from a refreshing pool to spacious floor plans. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Maize, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Watercress in Maize, KS. Choose from stylish one, two, or three-bedroom floor plans designed for comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Maize, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Watercress in Maize, KS! Enjoy a pool, fitness center, and pet-friendly spaces—your ideal home is here!",
  "property_seo_title_gallery": "Gallery | Apartments in Maize, KS",
  "property_seo_description_gallery": "Picture life at Watercress in Maize, KS! Enjoy stunning floor plans, resort-style amenities, and vibrant community vibes. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Watercress Apartments",
  "property_seo_description_virtualtours": "Experience Watercress in Maize, KS! Take a virtual tour of our one, two, and three-bedroom apartments, and envision your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Watercress Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Watercress in Maize, KS! Explore 1-3 bedroom options and enjoy amenities like a pool, fitness center, and dog park.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Maize, KS",
  "property_seo_description_neighborhood": "Immerse yourself in Maize, KS at Watercress. Uncover vibrant local favorites, attractions, and a welcoming community just steps from your door.",
  "property_seo_title_contact": "Contact Us | Watercress",
  "property_seo_description_contact": "Connect with Watercress in Maize, KS! Choose from stylish one, two, or three-bedroom floor plans. Our leasing team is ready to assist—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Maize, KS",
  "property_seo_description_faqs": "Uncover answers to your questions about Watercress in Maize, KS. From amenities to floor plans, our FAQs have you covered for a perfect living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Maize, KS",
  "property_seo_description_reviews": "Experience life at Watercress in Maize, KS! Read resident reviews on our spacious apartments, top-tier amenities, and vibrant community spirit.",
  "property_seo_title_applynow": "Apply Now | Apartments in Maize, KS",
  "property_seo_description_applynow": "Find your perfect home at Watercress, Maize, KS! Enjoy spacious floor plans, top-notch amenities, and vibrant community living. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Watercress",
  "property_seo_description_residentaccess": "Elevate your Watercress living experience in Maize, KS. Log in to your resident portal for easy rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Watercress",
  "property_seo_description_referafriend": "Refer a friend to Watercress in Maize, KS! Great friends create great neighbors—share the love and enjoy life at our vibrant apartment community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Watercress",
  "property_seo_description_scheduletour": "Experience Watercress in Maize, KS! Dive into comfort and style. Schedule your tour today and find your perfect home amidst lush surroundings!",
  "property_seo_title_privacy": "Privacy Policy | Watercress",
  "property_seo_description_privacy": "At Watercress in Maize, KS, your privacy matters. Learn how we protect your information and create a secure living environment. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Watercress",
  "property_seo_description_accessibility": "At Watercress in Maize, KS, we prioritize digital inclusion. Our accessibility statement ensures everyone enjoys a seamless online experience. Join us!",
  "property_seo_title_sitemap": "Sitemap | Watercress",
  "property_seo_description_sitemap": "Navigate through Watercress in Maize, KS! Find your perfect home with ease—check out our comprehensive sitemap for community features & amenities.",
  "property_seo_title_thankyou": "Thank You | Watercress",
  "property_seo_description_thankyou": "Thank you for your interest in Watercress in Maize, KS! Expect a quick response from our team to help you find your perfect new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Maize, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866143538",
  "amenities": [
    {
      "id": "ec_164fd5085c54637809cbf1ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397477",
      "title": "24-Hour Fitness Center with Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0114bd4d781372a38fb305b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397478",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a1db53349d6bb2f3d418dd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397479",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8ea975d07f429a407ab743e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397480",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c21099b313d5266568fed4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397481",
      "title": "Zero-Entry Swimming Pool with Outdoor Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1d7b50f479c3cdcfb83db7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397482",
      "title": "Clubhouse with Free WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e228a84567922eff3fbf840c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397483",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fcceb11d40322ffbb5bf376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397484",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea7bab0efc4cdd8f56780622",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397485",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31b08b4fb25ffbb76daa7f8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397486",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6f24ab9bbc0ed5fa823910b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397487",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33aaa11a411b78cfc27e1371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "128042523",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99d6ab55439a62ac8b5f3bb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127397488",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f80bcbcbb0a890315c5640a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398944",
      "title": "Generous Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b95f5f7af3c1c5a36851dcdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398945",
      "title": "Modern LED Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78b10f0d5e18d44054ceca75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398946",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22ed5bb976a866b31ddaaa62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398947",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb26a8086996ce41b71979b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398948",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e7c221e7069b13f215ead8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398949",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a0f5c9b9688f8b34c797000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398950",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1c4ca3f634d61a161651a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398951",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6dc4f52950ab2c8ededcc80e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398952",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d361e3cd44104b9aab79697",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398953",
      "title": "Spacious Living Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_455317774a2064a2df048cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398954",
      "title": "Gourmet Kitchens with Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c8eb1b635857d0f0bdff2a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398955",
      "title": "Loft Style Living Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3eb5a0760cd0bc742607e50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "yardi",
      "external_id": "127398956",
      "title": "Attached/Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_738810c2-01af-4e22-b9e0-72f78db0e982",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-3edf-7138-a6b5-1baab7209732.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fa4f0-3edf-7138-a6b5-1baab7209732",
        "storage_key": "property/6767906449166551/019fa4f0-3edf-7138-a6b5-1baab7209732.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a stainless steel range, microwave, and dishwasher, complemented by elegant white cabinetry and dark countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73b89bed-a561-4bbe-b621-6ce1d25287d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-357a-7015-a6e2-7080e2f3ba31.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace and large screen TV, a sofa, and a desk area.",
        "public_id": "019fa4f0-357a-7015-a6e2-7080e2f3ba31",
        "storage_key": "property/6767906449166551/019fa4f0-357a-7015-a6e2-7080e2f3ba31.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, perfect for relaxation and entertaining. Featuring a cozy fireplace, a large screen TV, and a dedicated workspace.",
      "link": "",
      "alt_text": "Modern living room with fireplace and large screen TV, a sofa, and a desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9c1920a-7f34-4c9f-ae23-bfbe805b4cbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-3788-71e0-827a-d453ebe01802.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar with stools.",
        "public_id": "019fa4f0-3788-71e0-827a-d453ebe01802",
        "storage_key": "property/6767906449166551/019fa4f0-3788-71e0-827a-d453ebe01802.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring ample cabinet space, a sleek countertop, and a convenient breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6cf70bb9-120d-49f0-ab88-c0f12102a2f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-23ce-771a-90b3-9195214aa8b7.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and four chairs, next to a living room with a sofa and decorative pillows.",
        "public_id": "019fa4f0-23ce-771a-90b3-9195214aa8b7",
        "storage_key": "property/6767906449166551/019fa4f0-23ce-771a-90b3-9195214aa8b7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a meal in the dining area or relax in the adjacent living room, both featuring tasteful decor and comfortable furnishings.",
      "link": "",
      "alt_text": "Dining area with a wooden table and four chairs, next to a living room with a sofa and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c89e5742-126b-4984-9b0e-9dd4d7d310be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-2687-724d-bc0b-969e2b6ca035.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019fa4f0-2687-724d-bc0b-969e2b6ca035",
        "storage_key": "property/6767906449166551/019fa4f0-2687-724d-bc0b-969e2b6ca035.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar overlooking the living area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95edc148-822b-44ec-b91b-a98df65b52d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-1f06-7428-a8fd-674a58c0855b.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
        "public_id": "019fa4f0-1f06-7428-a8fd-674a58c0855b",
        "storage_key": "property/6767906449166551/019fa4f0-1f06-7428-a8fd-674a58c0855b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and elegant decor. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa530b30-f288-4f00-afef-5312f4d7d2ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-1b81-759f-b409-ac356e502e7a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and dresser.",
        "public_id": "019fa4f0-1b81-759f-b409-ac356e502e7a",
        "storage_key": "property/6767906449166551/019fa4f0-1b81-759f-b409-ac356e502e7a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands, and a stylish dresser, perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8dd7d11a-5b40-4aba-a18a-c23c6eca00ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-20d1-75c1-8aac-8ab4f7969996.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fa4f0-20d1-75c1-8aac-8ab4f7969996",
        "storage_key": "property/6767906449166551/019fa4f0-20d1-75c1-8aac-8ab4f7969996.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring ample cabinet space, a dishwasher, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d39c72d1-f1be-48fd-9b48-123ad13167f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-1f0f-7280-84be-548155464735.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, TV, and open kitchen area.",
        "public_id": "019fa4f0-1f0f-7280-84be-548155464735",
        "storage_key": "property/6767906449166551/019fa4f0-1f0f-7280-84be-548155464735.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area flowing into a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, TV, and open kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_516cc35a-2c53-48bf-8f54-bc9656ed5f58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-0f31-731c-8c7a-38d596143fa7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, mirror, and toilet. Features a bathtub with a beige striped shower curtain.",
        "public_id": "019fa4f0-0f31-731c-8c7a-38d596143fa7",
        "storage_key": "property/6767906449166551/019fa4f0-0f31-731c-8c7a-38d596143fa7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this well-appointed apartment bathroom, complete with a spacious vanity, a soaking tub, and elegant finishes.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, mirror, and toilet. Features a bathtub with a beige striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2dc50eb1-b977-4fdc-851d-58824325fb22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-0304-709f-93d7-46f7c5562566.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, armchair, coffee table, and TV.",
        "public_id": "019fa4f0-0304-709f-93d7-46f7c5562566",
        "storage_key": "property/6767906449166551/019fa4f0-0304-709f-93d7-46f7c5562566.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, plush armchair, and entertainment center with a TV.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, armchair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a12d4e7-fc70-4565-a3f0-8dd099cfa1b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-0d0c-71cd-a777-0c66822380df.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019fa4f0-0d0c-71cd-a777-0c66822380df",
        "storage_key": "property/6767906449166551/019fa4f0-0d0c-71cd-a777-0c66822380df.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this clean and modern bathroom featuring a spacious vanity with ample storage, a sleek sink, a comfortable toilet, and a pristine bathtub with a white shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7aeb408d-df38-4854-b209-26f2121fd7ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-05fb-701b-91e5-a65ba3a05352.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, nightstands, and a ceiling fan.",
        "public_id": "019fa4f0-05fb-701b-91e5-a65ba3a05352",
        "storage_key": "property/6767906449166551/019fa4f0-05fb-701b-91e5-a65ba3a05352.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, ample storage, and stylish decor.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44a74363-57b4-4e76-a420-3b7e97bebbb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-02de-773b-828b-3cf66327f28c.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances, dark countertops, and bar stools.",
        "public_id": "019fa4f0-02de-773b-828b-3cf66327f28c",
        "storage_key": "property/6767906449166551/019fa4f0-02de-773b-828b-3cf66327f28c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this stylish kitchen featuring white cabinetry, granite countertops, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances, dark countertops, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e01cb8b-0279-4f25-9a5e-78fd52eda431",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-f350-72d9-a8b4-fc5fbc19a327.webp",
      "image_media": {
        "alt_text": "A stylish living room with a large sectional sofa, blue accent chair, and dining area with decorative mirrors.",
        "public_id": "019fa4ef-f350-72d9-a8b4-fc5fbc19a327",
        "storage_key": "property/6767906449166551/019fa4ef-f350-72d9-a8b4-fc5fbc19a327.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living and dining area, perfect for relaxing or entertaining guests. Features a comfortable sectional, accent chairs, and decorative accents.",
      "link": "",
      "alt_text": "A stylish living room with a large sectional sofa, blue accent chair, and dining area with decorative mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbd473d5-43a1-4c4c-9ade-7cf5e556cb58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-e159-7617-b5e3-0cb599c9608a.webp",
      "image_media": {
        "alt_text": "View from balcony of apartment complex pool area with lounge chairs and tables.",
        "public_id": "019fa4ef-e159-7617-b5e3-0cb599c9608a",
        "storage_key": "property/6767906449166551/019fa4ef-e159-7617-b5e3-0cb599c9608a.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy the view from your private balcony overlooking the resort-style pool and lush landscaping. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "View from balcony of apartment complex pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20039bb5-274b-4d22-b246-803134af88dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-e01a-75e8-8b2a-b7f8c561b57f.webp",
      "image_media": {
        "alt_text": "Dining room with a table and four chairs, large windows with blinds, and sheer curtains.",
        "public_id": "019fa4ef-e01a-75e8-8b2a-b7f8c561b57f",
        "storage_key": "property/6767906449166551/019fa4ef-e01a-75e8-8b2a-b7f8c561b57f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this inviting dining space, perfect for family dinners or entertaining guests. Large windows provide ample natural light.",
      "link": "",
      "alt_text": "Dining room with a table and four chairs, large windows with blinds, and sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f23e08bb-2505-4975-b873-21000e8b65eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-de49-7570-87a0-372f8824d5ee.webp",
      "image_media": {
        "alt_text": "Desk and dining area in a luxury apartment.",
        "public_id": "019fa4ef-de49-7570-87a0-372f8824d5ee",
        "storage_key": "property/6767906449166551/019fa4ef-de49-7570-87a0-372f8824d5ee.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Create your ideal workspace and dining experience in this stylish apartment featuring a dedicated desk area and elegant dining set.",
      "link": "",
      "alt_text": "Desk and dining area in a luxury apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5400c26e-34a7-4c52-9237-e9d29ea79f30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-9a4e-7268-982f-d43678896583.webp",
      "image_media": {
        "alt_text": "Neutral bedroom with a queen-size bed, dresser, nightstand, and ceiling fan.",
        "public_id": "019fa4ef-9a4e-7268-982f-d43678896583",
        "storage_key": "property/6767906449166551/019fa4ef-9a4e-7268-982f-d43678896583.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a queen-size bed, ample storage, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Neutral bedroom with a queen-size bed, dresser, nightstand, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf7a01ab-56bd-4669-936a-4f1d7226dbbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-9294-723d-a96c-eff4885cd2d5.webp",
      "image_media": {
        "alt_text": "Luxurious seating area with a fireplace, modern chandelier, and large windows.",
        "public_id": "019fa4ef-9294-723d-a96c-eff4885cd2d5",
        "storage_key": "property/6767906449166551/019fa4ef-9294-723d-a96c-eff4885cd2d5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and elegant decor.",
      "link": "",
      "alt_text": "Luxurious seating area with a fireplace, modern chandelier, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_375564e4-c7f2-4e20-8470-702a47553732",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-94df-7235-81fa-4bfb0bf2e535.webp",
      "image_media": {
        "alt_text": "Clubhouse kitchen and reception area with bar seating and computers.",
        "public_id": "019fa4ef-94df-7235-81fa-4bfb0bf2e535",
        "storage_key": "property/6767906449166551/019fa4ef-94df-7235-81fa-4bfb0bf2e535.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our modern clubhouse, featuring a fully equipped kitchen, a stylish reception desk with computers, and comfortable bar seating for residents.",
      "link": "",
      "alt_text": "Clubhouse kitchen and reception area with bar seating and computers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc2eb1e9-ce37-44cb-869e-8db368cc0d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-8f93-776d-8008-c2ce4402c5b3.webp",
      "image_media": {
        "alt_text": "Community business center with seating and workstations.",
        "public_id": "019fa4ef-8f93-776d-8008-c2ce4402c5b3",
        "storage_key": "property/6767906449166551/019fa4ef-8f93-776d-8008-c2ce4402c5b3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "This community business center offers a comfortable seating area and well-equipped workstations for residents to use for work or study.",
      "link": "",
      "alt_text": "Community business center with seating and workstations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f3a95c5-045f-4d12-a28b-e5439a20fff5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-6ebd-7179-a043-391eb3b0024f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables, umbrellas, fireplace, and grill next to a swimming pool.",
        "public_id": "019fa4ef-6ebd-7179-a043-391eb3b0024f",
        "storage_key": "property/6767906449166551/019fa4ef-6ebd-7179-a043-391eb3b0024f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community amenities, including a pool, grill, and fireplace area, perfect for relaxation and gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic tables, umbrellas, fireplace, and grill next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58a72c34-9b3b-4f59-b834-91e0ea168372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-6f42-778a-a1f5-721b6ec79e3f.webp",
      "image_media": {
        "alt_text": "Outdoor patio with picnic tables, grills, and a fireplace.",
        "public_id": "019fa4ef-6f42-778a-a1f5-721b6ec79e3f",
        "storage_key": "property/6767906449166551/019fa4ef-6f42-778a-a1f5-721b6ec79e3f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with built-in grills, comfortable seating, and a cozy fireplace in our community patio area.",
      "link": "",
      "alt_text": "Outdoor patio with picnic tables, grills, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8572500-acb2-461e-943c-fff459f12506",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-d95e-744c-8f41-b4709a3d28d2.webp",
      "image_media": {
        "alt_text": "Apartment complex with a swimming pool, lounge chairs, and a water feature.",
        "public_id": "019fa4ee-d95e-744c-8f41-b4709a3d28d2",
        "storage_key": "property/6767906449166551/019fa4ee-d95e-744c-8f41-b4709a3d28d2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and beautifully landscaped grounds. Relax by the water or take a stroll through our vibrant community.",
      "link": "",
      "alt_text": "Apartment complex with a swimming pool, lounge chairs, and a water feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30f3969a-4668-4b30-b51a-dbfa55938885",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-d990-748c-b4f7-89e77c6624af.webp",
      "image_media": {
        "alt_text": "Watercress Apartment Homes monument sign with buildings in the background.",
        "public_id": "019fa4ee-d990-748c-b4f7-89e77c6624af",
        "storage_key": "property/6767906449166551/019fa4ee-d990-748c-b4f7-89e77c6624af.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Watercress Apartment Homes, featuring beautiful landscaping and architecture.",
      "link": "",
      "alt_text": "Watercress Apartment Homes monument sign with buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f58a519-3e8a-49e1-8ab7-6a90f6ec22a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-c860-72dd-832a-e05c1cb5b499.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
        "public_id": "019fa4ee-c860-72dd-832a-e05c1cb5b499",
        "storage_key": "property/6767906449166551/019fa4ee-c860-72dd-832a-e05c1cb5b499.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the architectural style and the convenient parking facilities.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e61b7d07-0859-4987-9647-287e6cb174e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-c7f3-716f-840b-b2316c7e6c0f.webp",
      "image_media": {
        "alt_text": "Townhomes with attached garages and a parking lot.",
        "public_id": "019fa4ee-c7f3-716f-840b-b2316c7e6c0f",
        "storage_key": "property/6767906449166551/019fa4ee-c7f3-716f-840b-b2316c7e6c0f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of townhome units featuring attached garages and a paved parking area.",
      "link": "",
      "alt_text": "Townhomes with attached garages and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18613fb0-ae28-48fe-a043-72e196ef5d95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-d1ac-7593-9320-1ffa1d7d7af9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages.",
        "public_id": "019fa4ee-d1ac-7593-9320-1ffa1d7d7af9",
        "storage_key": "property/6767906449166551/019fa4ee-d1ac-7593-9320-1ffa1d7d7af9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, featuring individual garages for residents. This image showcases the community's infrastructure and convenient parking options.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c1e1341-1c26-4b31-8665-6faccdd4dc64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-9e2c-770e-824c-1b4e8b42eb44.webp",
      "image_media": {
        "alt_text": "Exterior of a tan apartment building with multiple balconies and green lawn.",
        "public_id": "019fa4ee-9e2c-770e-824c-1b4e8b42eb44",
        "storage_key": "property/6767906449166551/019fa4ee-9e2c-770e-824c-1b4e8b42eb44.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "The exterior of a modern apartment building, featuring multiple levels of balconies, tan siding, and a well-maintained green lawn with a walking path.",
      "link": "",
      "alt_text": "Exterior of a tan apartment building with multiple balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa5ba4ec-cec1-4643-bb0c-fa732a57c0b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-adde-769a-9aac-a4e3192a90b1.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a pond and fountains in front.",
        "public_id": "019fa4ee-adde-769a-9aac-a4e3192a90b1",
        "storage_key": "property/6767906449166551/019fa4ee-adde-769a-9aac-a4e3192a90b1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Expansive apartment buildings feature balconies and are set against a clear blue sky, with a serene pond and fountains in the foreground, surrounded by lush green lawns.",
      "link": "",
      "alt_text": "Apartment buildings with a pond and fountains in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8122f70-f61c-4b81-8eec-602126d3f23e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-b602-759e-8ae4-38dafe8dc884.webp",
      "image_media": {
        "alt_text": "Dog park signage and benches at apartment complex",
        "public_id": "019fa4ee-b602-759e-8ae4-38dafe8dc884",
        "storage_key": "property/6767906449166551/019fa4ee-b602-759e-8ae4-38dafe8dc884.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Canine Cove, the pet-friendly park at this apartment community. Enjoy the outdoor space with your furry friends.",
      "link": "",
      "alt_text": "Dog park signage and benches at apartment complex",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6eb0f43b-ce13-41e5-9837-3fb4db7c95e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-b536-76f9-b8f3-62d573cc9391.webp",
      "image_media": {
        "alt_text": "Apartment complex with a fenced-in dog park featuring agility equipment.",
        "public_id": "019fa4ee-b536-76f9-b8f3-62d573cc9391",
        "storage_key": "property/6767906449166551/019fa4ee-b536-76f9-b8f3-62d573cc9391.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park with agility equipment, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Apartment complex with a fenced-in dog park featuring agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e0d1abc-0240-44eb-a9b0-a8c6a50c3440",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-9395-7798-a01d-015d28585e7b.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a fountain in a pond.",
        "public_id": "019fa4ee-9395-7798-a01d-015d28585e7b",
        "storage_key": "property/6767906449166551/019fa4ee-9395-7798-a01d-015d28585e7b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a serene pond and fountain, offering a picturesque living environment.",
      "link": "",
      "alt_text": "Apartment buildings with a fountain in a pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_011750b2-ab00-4a80-8a4e-169f724552ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-88c0-71e8-879b-0b1322812003.webp",
      "image_media": {
        "alt_text": "Covered patio seating area with blue couches and a wooden pergola.",
        "public_id": "019fa4ee-88c0-71e8-879b-0b1322812003",
        "storage_key": "property/6767906449166551/019fa4ee-88c0-71e8-879b-0b1322812003.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, complete with a shaded pergola and plush blue furniture.",
      "link": "",
      "alt_text": "Covered patio seating area with blue couches and a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2d973d5-946b-4c09-b49f-6fa635e8f783",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-7482-7199-8ab5-14be86410fc0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fa4ee-7482-7199-8ab5-14be86410fc0",
        "storage_key": "property/6767906449166551/019fa4ee-7482-7199-8ab5-14be86410fc0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the resort-style pool, featuring comfortable lounge chairs and a beautiful backdrop of the apartment community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d919dfa-a7c7-4f41-9a2e-0c17c3e8df3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-6daf-723a-abd5-6c13d1a5121d.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large blue swimming pool and lounge chairs.",
        "public_id": "019fa4ee-6daf-723a-abd5-6c13d1a5121d",
        "storage_key": "property/6767906449166551/019fa4ee-6daf-723a-abd5-6c13d1a5121d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our expansive swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Apartment complex with a large blue swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3b30233-6cfc-48ad-afeb-04ca3ab3ccfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-6dd7-761b-8609-3ed5999a8627.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with brick walls, blue seating, and a tropical wall painting.",
        "public_id": "019fa4ee-6dd7-761b-8609-3ed5999a8627",
        "storage_key": "property/6767906449166551/019fa4ee-6dd7-761b-8609-3ed5999a8627.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable seating and a tropical-inspired ambiance. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with brick walls, blue seating, and a tropical wall painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_36a9e379-fd6c-44b0-9262-6bf2f5e251c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-6da9-738b-9f57-52306dc620b3.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and a stucco building with a red tile roof.",
        "public_id": "019fa4ee-6da9-738b-9f57-52306dc620b3",
        "storage_key": "property/6767906449166551/019fa4ee-6da9-738b-9f57-52306dc620b3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs and a stucco building with a red tile roof.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_050ab3ca-c27e-4d20-8048-60ca5b5518d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-6da4-76e4-b44e-377694cc178f.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with blue cushioned furniture near a swimming pool.",
        "public_id": "019fa4ee-6da4-76e4-b44e-377694cc178f",
        "storage_key": "property/6767906449166551/019fa4ee-6da4-76e4-b44e-377694cc178f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in the shaded outdoor lounge area, complete with comfortable seating and a refreshing swimming pool nearby.",
      "link": "",
      "alt_text": "Covered outdoor seating area with blue cushioned furniture near a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d6b852d-113a-424f-aa99-27d6d014a344",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-55ea-70fe-92da-bc5e3a9da4db.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fa4ee-55ea-70fe-92da-bc5e3a9da4db",
        "storage_key": "property/6767906449166551/019fa4ee-55ea-70fe-92da-bc5e3a9da4db.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by comfortable lounge chairs and umbrellas. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8ee20747-aebc-4681-b548-482228320bb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "3220 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "People say this restaurant serves delicious burgers, sandwiches, and frozen custard. They also highlight the friendly staff, clean atmosphere, and efficient drive-thru service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4398-7537-9b7f-69aa7d092140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4398-7537-9b7f-69aa7d092140",
        "storage_key": "property/6767906449166551/019cfb50-4398-7537-9b7f-69aa7d092140.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.culvers.com/restaurants/wichita-ks-n-maize-rd/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3177687827998515316&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "37.741036",
      "poi_longitude": "-97.4618046",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-796-5569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8Ax95Uhu4cRdCDvUj5qGSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_bca6d69f-c101-4bb9-999a-d0b83600fa63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Tacos TJ 664",
      "poi_type": "Restaurants",
      "poi_address": "1014 N West St, Wichita, KS 67203, USA",
      "poi_short_description": "Casual restaurant (part of a chain) dishing out Mexican plates such as tacos, burritos and quesadillas, plus beer and margaritas.",
      "poi_long_description": "People say this taco restaurant serves authentic and flavorful birria tacos, carne asada fries, and quesadillas. They highlight the generous portions, affordable prices, and great value. They also like the friendly staff and laid-back atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-6ea3-736c-860d-962da4c85f49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6ea3-736c-860d-962da4c85f49",
        "storage_key": "property/6767906449166551/019cfb50-6ea3-736c-860d-962da4c85f49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tacostj664.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10506997636259729300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacos-tj-664",
      "poi_latitude": "37.7020358",
      "poi_longitude": "-97.3891816",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-461-0610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53QS5_fjuocRlE8hha5a0JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_517bb0b0-d64f-437e-a3ab-7d4e5dbf4621",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10515 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers a variety of menu items. They highlight the fast service and the staff's attentiveness. They also like the staff's willingness to go the extra mile.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-6e7a-71e9-a4d9-25ec0a66ffe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6e7a-71e9-a4d9-25ec0a66ffe0",
        "storage_key": "property/6767906449166551/019cfb50-6e7a-71e9-a4d9-25ec0a66ffe0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/21st-maize?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8794620218888915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.7220929",
      "poi_longitude": "-97.4639441",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-721-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlWl6wpXfuocRtIhXQX7EDHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d12992ad-b574-4b8a-ac41-23d0f6233e84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "560 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Cozy, family-friendly spot serving Mediterranean fare and vegetarian dishes, plus a full bar.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious garlic chicken, shawarma, and hummus, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, healthy options, and fast service. They also like the clean and inviting atmosphere, and the friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-6ea7-725a-a092-1fe7167624a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6ea7-725a-a092-1fe7167624a5",
        "storage_key": "property/6767906449166551/019cfb50-6ea7-725a-a092-1fe7167624a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.meddys.com/contact-us/locations/meddys-west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12281140395180920003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "37.6748359",
      "poi_longitude": "-97.4255422",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-500-3383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0FrWmXhuocRw4x1Ax9gb6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_6ebb45e0-05df-4e45-ad72-b2dc4c5f7bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home and garden projects. They also highlight the helpful and professional staff, and the well-stocked and clean store.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-43b2-7046-b60d-800ce06bdf34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-43b2-7046-b60d-800ce06bdf34",
        "storage_key": "property/6767906449166551/019cfb50-43b2-7046-b60d-800ce06bdf34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Wichita/KS/Wichita/67209/2205?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722908378629795426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.6738686",
      "poi_longitude": "-97.4402648",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ0S0uR3euocRYu51mXaQcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e898fba5-596b-45ac-906d-2e90365ecb9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3660 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of building supplies, hardware, patio equipment, appliances, paint, lighting, and lawn and garden decor. They also highlight the good prices, easy returns, and helpful staff.\n\nOther reviews mention the store can be difficult to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4399-753c-a9a6-e06603f976b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4399-753c-a9a6-e06603f976b6",
        "storage_key": "property/6767906449166551/019cfb50-4399-753c-a9a6-e06603f976b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3276&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195684929713849559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.7497617",
      "poi_longitude": "-97.4597743",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-729-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp792U3Igu4cR18QNwTYROjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_9b3abee6-b65b-4c94-a08f-a1c343895166",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great collection of plants. They also highlight the staff is helpful and easy to park.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4377-7639-b3b7-3035b9963c9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4377-7639-b3b7-3035b9963c9c",
        "storage_key": "property/6767906449166551/019cfb50-4377-7639-b3b7-3035b9963c9c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/0614?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-614-_-na-_-0-_-0&y_source=1_MTE4MzEwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050313256936817436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "37.678859",
      "poi_longitude": "-97.428188",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-773-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUZP16LguocRHEPaHJLhnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e863c557-43b5-42c7-96b0-4f39569dee9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Thai Binh Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 W 21st St, Wichita, KS 67203, USA",
      "poi_short_description": "Sprawling Asian-style grocery stocking produce and cooking utensils, plus hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-43ae-73e0-bf4b-d89106a0da58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-43ae-73e0-bf4b-d89106a0da58",
        "storage_key": "property/6767906449166551/019cfb50-43ae-73e0-bf4b-d89106a0da58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Thai-Binh-Supermarket/165438916815347",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975717193484190098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thai-binh-supermarket",
      "poi_latitude": "37.723579",
      "poi_longitude": "-97.355179",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-838-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5874-7078-a5fe-cc14b502bf51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5874-7078-a5fe-cc14b502bf51",
        "storage_key": "property/6767906449166551/019cfb50-5874-7078-a5fe-cc14b502bf51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMceJz4vhuocRksGNBwoCE7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_0c7608f5-9c42-47fe-a056-14c38450ac40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Dillons Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "10222 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "Supermarket chain with mainstream grocery items, plus natural & organic foods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh flowers, fruits, and vegetables, as well as a large seasonal holiday section. They also highlight the clean and well-stocked store, and the friendly, helpful, and efficient staff.\n\nOther reviews mention the security system can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-439a-732b-834e-8b3fb24ee023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-439a-732b-834e-8b3fb24ee023",
        "storage_key": "property/6767906449166551/019cfb50-439a-732b-834e-8b3fb24ee023.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillons.com/stores/grocery/ks/wichita/21st-maize-marketplace/615/00049?cid=loc_61500049_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11397950705259247415&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dillons-marketplace",
      "poi_latitude": "37.7239771",
      "poi_longitude": "-97.4610686",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-729-1530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5874-7078-a5fe-cc14b502bf51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5874-7078-a5fe-cc14b502bf51",
        "storage_key": "property/6767906449166551/019cfb50-5874-7078-a5fe-cc14b502bf51.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYGGOZXfuocRN_djCsenLZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4f492fc8-04ed-4047-b1c7-63f0cff3c140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Wichita Public Library - Westlink Branch",
      "poi_type": "Education",
      "poi_address": "8515 Bekemeyer St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, TV series, and audiobooks. They highlight the renovated space is beautiful, clean, and comfortable, with plenty of seating and outlets. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-484e-72ec-b033-319e8b57097d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-484e-72ec-b033-319e8b57097d",
        "storage_key": "property/6767906449166551/019cfb50-484e-72ec-b033-319e8b57097d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wichitalibrary.org/locations/pages/westlink.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6971528439597698411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---westlink-branch",
      "poi_latitude": "37.696964",
      "poi_longitude": "-97.4415485",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-337-9456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmzQVxiveuocRaw3B1y3Yv2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e3d57ef3-4405-459e-ab66-f303c5647ae2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "Visitors say this zoo offers a variety of animal experiences, including giraffe feeding, stingray cove, a train ride, and a boat ride, and they praise the well-maintained habitats and friendly staff. They also highlight the family-friendly atmosphere, affordable season passes, and numerous special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-707f-7028-bfa6-ab9ce5334ea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-707f-7028-bfa6-ab9ce5334ea1",
        "storage_key": "property/6767906449166551/019cfb50-707f-7028-bfa6-ab9ce5334ea1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_6a82e636-a36c-4d5d-99f4-cf9a3103f775",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8545 W Irving St, Wichita, KS 67209, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a ropes course. They also highlight the clean facility and the friendly, helpful staff.\n\nOther reviews mention the height requirements can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4898-72dd-98bc-8786ba6a5a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4898-72dd-98bc-8786ba6a5a5f",
        "storage_key": "property/6767906449166551/019cfb50-4898-72dd-98bc-8786ba6a5a5f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/kansas-wichita/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075506925871037131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "37.6701433",
      "poi_longitude": "-97.4414467",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-281-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITbj0RzeuocRy_pbug9AMWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1a321205-02e5-4e0c-b17e-32a22862b422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "All Star Sports",
      "poi_type": "Entertainment",
      "poi_address": "8333 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "All-ages amusement park offering mini-golf, go-karts, bumper boats, arcade games & a climbing wall.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including go-karts, mini golf, and an arcade. They also highlight the friendly staff and the family-friendly atmosphere.\n\nOther reviews mention the attractions can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-715a-766b-9d46-4c8877cd8975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-715a-766b-9d46-4c8877cd8975",
        "storage_key": "property/6767906449166551/019cfb50-715a-766b-9d46-4c8877cd8975.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.allstarwichita.com/sports/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1428230526315511839&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "all-star-sports",
      "poi_latitude": "37.7219229",
      "poi_longitude": "-97.4382853",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-722-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRcLIBeDfuocRH8BnuhgY0hM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_f636f7ad-e5cf-4fa0-bdb8-de715671af8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Elephants of the Zambezi River Valley",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-7198-741b-bb82-19a44a2a6dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-7198-741b-bb82-19a44a2a6dd0",
        "storage_key": "property/6767906449166551/019cfb50-7198-741b-bb82-19a44a2a6dd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12825493113809432942&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elephants-of-the-zambezi-river-valley",
      "poi_latitude": "37.7137031",
      "poi_longitude": "-97.409417",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2etukTguocRbnHU3QhO_bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_79be50a5-02db-44f0-ae29-71a4a7eaec2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "The Lucky Tree/Wishing Tree",
      "poi_type": "Entertainment",
      "poi_address": "KS-96, Colwich, KS 67030, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-715b-77d5-aca3-d5ce6e8d3f87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-715b-77d5-aca3-d5ce6e8d3f87",
        "storage_key": "property/6767906449166551/019cfb50-715b-77d5-aca3-d5ce6e8d3f87.webp",
        "width": 921,
        "height": 1152
      },
      "poi_business_url": "https://www.facebook.com/groups/107305225956210",
      "poi_directions_map_url": "https://maps.google.com/?cid=17685249895388073945&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-lucky-treewishing-tree",
      "poi_latitude": "37.8182452",
      "poi_longitude": "-97.5093695",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93ll6E4hu4cR2c-eUhShbvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_ba96f219-e167-407a-ba88-920ce99923e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "WEST YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "6940 Newell St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including yoga, and has a kid zone. They also highlight the friendly staff and welcoming, homely vibe.\n\nOther reviews mention billing issues can be difficult to resolve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-727e-70cd-8b67-288e3d98cfa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-727e-70cd-8b67-288e3d98cfa4",
        "storage_key": "property/6767906449166551/019cfb50-727e-70cd-8b67-288e3d98cfa4.webp",
        "width": 504,
        "height": 378
      },
      "poi_business_url": "https://www.ymcawichita.org/locations/west-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228409214553971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6928199",
      "poi_longitude": "-97.4231272",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-942-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-onBo7guocRPFx6DsdTrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f47ecb99-50ab-4526-a262-04b363e223d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Ken Shannon NORTHWEST Branch - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "13838 W 21st St N, Wichita, KS 67235, USA",
      "poi_short_description": "Familiar fitness club offering workout machines, classes (including swimming, yoga and Pilates), a pool and friendly staff, plus a sauna and steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4b4f-74ec-b096-356ca19cb195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4b4f-74ec-b096-356ca19cb195",
        "storage_key": "property/6767906449166551/019cfb50-4b4f-74ec-b096-356ca19cb195.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://ymcawichita.org/locations/ken-shannon-northwest-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593200057211516548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-shannon-northwest-branch---greater-wichita-ymca",
      "poi_latitude": "37.7232046",
      "poi_longitude": "-97.5035287",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-260-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5XYsWvfuocRhHYtD4XAf1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2395e861-e840-4356-8227-4b370924a122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Veterinary Emergency & Specialty Hospital of Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "5618 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-727e-70cd-8b67-24f0cb6e3f32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-727e-70cd-8b67-24f0cb6e3f32",
        "storage_key": "property/6767906449166551/019cfb50-727e-70cd-8b67-24f0cb6e3f32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vetwichita.com/?y_source=1_MTUyMjkzNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9151561644725192073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency--specialty-hospital-of-wichita",
      "poi_latitude": "37.7241153",
      "poi_longitude": "-97.4087979",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-262-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_YLl43juocRiUXvLdTgAH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_91e25cf7-c89a-4814-9a68-f63ae29edfcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West Central",
      "poi_type": "Health and Wellness",
      "poi_address": "854 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "Gym and tennis club featuring weight machines, group classes, personal trainers, a pool, saunas and clean locker rooms.",
      "poi_long_description": "People say this gym offers personal training packages and nutrient products. They also highlight the 24-hour access.\n\nOther reviews mention the equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4b05-702a-8e0a-ba0b537e0166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4b05-702a-8e0a-ba0b537e0166",
        "storage_key": "property/6767906449166551/019cfb50-4b05-702a-8e0a-ba0b537e0166.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3017945090160134620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-central",
      "poi_latitude": "37.6974426",
      "poi_longitude": "-97.4363575",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-721-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQpmYNjfuocR3Amh2hHl4Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_836fe8cc-1ccb-4fd2-9a22-b46178a5e982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Limitless Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "8635 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Barbershop offering a variety of haircuts, including fades, in a friendly setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4ba2-764b-927f-a0ad4303e2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4ba2-764b-927f-a0ad4303e2c5",
        "storage_key": "property/6767906449166551/019cfb50-4ba2-764b-927f-a0ad4303e2c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.limitlessbarbershop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406037866442402230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "limitless-barbershop",
      "poi_latitude": "37.6927246",
      "poi_longitude": "-97.4428108",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-469-8087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwzn3G_fuocRtilwGbH2YyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_843d21a4-5d3e-4684-9ab6-b153f7a9f9fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2350 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Gym chain with a large network of locations, offering tanning, and massage chairs.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including six Smith machines, and provides access to hydrotherapy, tanning, and red light therapy. They also highlight the clean facility, convenient 24/7 access, and friendly, welcoming staff.\n\nOther reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-73e5-72f8-8ae0-2737e56a1a76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-73e5-72f8-8ae0-2737e56a1a76",
        "storage_key": "property/6767906449166551/019cfb50-73e5-72f8-8ae0-2737e56a1a76.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-maize-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7469593839999626477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.72603170000001",
      "poi_longitude": "-97.4613033",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-440-5520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE_knmJTfuocR7ayfmQVUqWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_912ad88f-55fc-45b1-9b64-c782bbb51d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Sisters Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 N Maize Rd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4e18-77aa-b648-a6cb0d8c3f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4e18-77aa-b648-a6cb0d8c3f1b",
        "storage_key": "property/6767906449166551/019cfb50-4e18-77aa-b648-a6cb0d8c3f1b.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://sistersveterinaryclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9015111672864609835&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sisters-veterinary-clinic",
      "poi_latitude": "37.7175909",
      "poi_longitude": "-97.463296",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-722-6240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0TsnxjeuocRK5aSZ00cHH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0bd01be6-27eb-43b6-af69-4d30b4e38f0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Pet Haven Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2518 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4e43-7581-a9ee-9652777d2ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4e43-7581-a9ee-9652777d2ee5",
        "storage_key": "property/6767906449166551/019cfb50-4e43-7581-a9ee-9652777d2ee5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pethavenvet.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg5NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=840751103377657738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pet-haven-veterinary-clinic",
      "poi_latitude": "37.7092222",
      "poi_longitude": "-97.3722387",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 316-942-2531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1b9Tbp_huocRis9Xjazyqgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_08d84332-1d57-458e-8233-0a672a76826e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West 13TH",
      "poi_type": "Health and Wellness",
      "poi_address": "3725 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Chain offering fitness and strength training facilities (with heavy bags at one location) alongside classes (including martial arts and yoga ones) as well as personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-4f87-77dd-972a-e8f6c3021496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-4f87-77dd-972a-e8f6c3021496",
        "storage_key": "property/6767906449166551/019cfb50-4f87-77dd-972a-e8f6c3021496.webp",
        "width": 862,
        "height": 485
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-13th.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14791271163472267679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-13th",
      "poi_latitude": "37.708327",
      "poi_longitude": "-97.3870283",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-945-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6bR5ajhuocRn0k-c8EmRc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e192ee60-bc05-4c73-b638-308c90a7b102",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-754e-725f-8253-ac85be42f12d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-754e-725f-8253-ac85be42f12d",
        "storage_key": "property/6767906449166551/019cfb50-754e-725f-8253-ac85be42f12d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15586166186925347435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-teresa",
      "poi_latitude": "37.7257513",
      "poi_longitude": "-97.5132964",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-796-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-36ed93b0061e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-36ed93b0061e",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-36ed93b0061e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVzCgkXfuocRa9LjZZEvTdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4b48baff-5b82-4fbc-948d-6a49c742abd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Ascension Medical Group Via Christi on St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14700 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-75c5-757e-bdf2-510a17509281.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-75c5-757e-bdf2-510a17509281",
        "storage_key": "property/6767906449166551/019cfb50-75c5-757e-bdf2-510a17509281.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa/departments/medical-office-building/primary-care?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6264593793723266945&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-medical-group-via-christi-on-st-teresa",
      "poi_latitude": "37.7256125",
      "poi_longitude": "-97.5130382",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-274-0142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-36ed93b0061e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-36ed93b0061e",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-36ed93b0061e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyeofE_fuocRgff9ON1O8FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_ebdad5e0-ddc0-4902-91d4-2384faee33a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Sedgwick County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Center for outdoor sports, recreation & fitness, with fishing on 4 lakes, plus shelter rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking and biking trails, fishing, and picnic areas. They highlight the spaciousness, beautiful scenery, and family-friendly atmosphere. They also like the well-maintained facilities and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-50ff-7223-8a6f-7431c55a46df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-50ff-7223-8a6f-7431c55a46df",
        "storage_key": "property/6767906449166551/019cfb50-50ff-7223-8a6f-7431c55a46df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sedgwickcounty.org/parks/sedgwick-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1140188679586598057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-park",
      "poi_latitude": "37.7093827",
      "poi_longitude": "-97.4184872",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-660-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-feb993e472a5",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6auLGjguocRqUyuJ5DD0g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_259d3664-9fab-4e53-ae75-e45b30e7372e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Auburn Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "443 S 135th St W, Wichita, KS 67235, USA",
      "poi_short_description": "Public course featuring 18 holes with tight corridors, rolling hills and wetlands areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-50cb-72c9-8059-04a33bc9780d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-50cb-72c9-8059-04a33bc9780d",
        "storage_key": "property/6767906449166551/019cfb50-50cb-72c9-8059-04a33bc9780d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Auburn-Hills-Golf-Course-148",
      "poi_directions_map_url": "https://maps.google.com/?cid=15217307189274254099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-hills-golf-course",
      "poi_latitude": "37.6740167",
      "poi_longitude": "-97.4989223",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-219-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-589c-77bb-8079-02c6e8d7bdef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-589c-77bb-8079-02c6e8d7bdef",
        "storage_key": "property/6767906449166551/019cfb50-589c-77bb-8079-02c6e8d7bdef.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4geZefiuocRE5uwjkO8LtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_60bab728-bca2-4657-9572-5e605092b81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Swanson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10421 W Harvest Ct, Wichita, KS 67212, USA",
      "poi_short_description": "Beautiful park with deer and a creek, plus scenic trails for hiking, walking and bicycling.",
      "poi_long_description": "People say this park offers peaceful walks with opportunities to see deer, ducks, and turtles. They highlight the clean paths, untouched natural beauty within the city limits, and the availability of short or long walks. They also like the quiet and tranquil atmosphere, perfect for solo walks or with friends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-774e-7794-8b44-1b4d2c58c38b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-774e-7794-8b44-1b4d2c58c38b",
        "storage_key": "property/6767906449166551/019cfb50-774e-7794-8b44-1b4d2c58c38b.webp",
        "width": 469,
        "height": 429
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Swanson-Park-205",
      "poi_directions_map_url": "https://maps.google.com/?cid=15699369471649279504&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "swanson-park",
      "poi_latitude": "37.70068",
      "poi_longitude": "-97.4633284",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-219-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-feb993e472a5",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QWr-0zeuocREG5EC1td39k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_44eb6cf1-1c8a-4a60-8f3e-eea9adb450d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Reflection Ridge Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7700 W Reflection Rd, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-53a1-77f0-8e41-b2575c4ecaf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-53a1-77f0-8e41-b2575c4ecaf4",
        "storage_key": "property/6767906449166551/019cfb50-53a1-77f0-8e41-b2575c4ecaf4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://reflectionridgegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17094841704819312163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reflection-ridge-golf-course",
      "poi_latitude": "37.727246",
      "poi_longitude": "-97.432121",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-721-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-589c-77bb-8079-02c6e8d7bdef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-589c-77bb-8079-02c6e8d7bdef",
        "storage_key": "property/6767906449166551/019cfb50-589c-77bb-8079-02c6e8d7bdef.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwb5DAzguocRI8ZJS_UTPe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_89fbf225-22c1-4b07-a32c-9d46a747c784",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Brown Thrush Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Brown Thrush Park, 533 N Country Acres Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Park with swings, slides and other playground equipment for kids, plus baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-77cd-73c8-8860-9995e67dd509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-77cd-73c8-8860-9995e67dd509",
        "storage_key": "property/6767906449166551/019cfb50-77cd-73c8-8860-9995e67dd509.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wichita.gov/facilities/facility/details/Brownthrush-Park-47",
      "poi_directions_map_url": "https://maps.google.com/?cid=9515936859885657422&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brown-thrush-park",
      "poi_latitude": "37.6905879",
      "poi_longitude": "-97.4321758",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-feb993e472a5",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-feb993e472a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCdZfEpvguocRTt2HDihmD4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_4a2c04a7-9e6a-4019-a16d-d7210ef9756e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Fugate Enterprises",
      "poi_type": "Major Employers & Offices",
      "poi_address": "208 S Maize Rd, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7448891536358081377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fugate-enterprises",
      "poi_latitude": "37.6807629",
      "poi_longitude": "-97.4620159",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-722-5670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVtHTkDeuocRYYMJ62LHX2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_63706b7c-6f01-4498-89d3-5b7d7fb9dbf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Hampel Oil Distributors, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3531 N Ridge Rd UPPR 2, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-77a2-73e8-b100-dce05eb646ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-77a2-73e8-b100-dce05eb646ce",
        "storage_key": "property/6767906449166551/019cfb50-77a2-73e8-b100-dce05eb646ce.webp",
        "width": 585,
        "height": 1280
      },
      "poi_business_url": "http://www.hampeloil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11698373111707813341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hampel-oil-distributors-inc",
      "poi_latitude": "37.748387",
      "poi_longitude": "-97.4271508",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-529-1162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmz7aMarhuocR3UVTTV34WKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_df0e1faa-e208-4c5f-8447-03774e4bc172",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Pathway Church Central Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2001 N Maize Rd, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pathwaychurch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5448405997113274486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pathway-church-central-office",
      "poi_latitude": "37.7195462",
      "poi_longitude": "-97.4649381",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-722-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsz2MdL7fuocRdnALMmOgnEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6a181a99-77bb-45b0-bc29-b8a64dff3f15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-bb9c-70b3-a1a5-8a08e89744ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bb9c-70b3-a1a5-8a08e89744ac",
        "storage_key": "property/6767906449166551/019d7915-bb9c-70b3-a1a5-8a08e89744ac.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_75a1b884-0bfe-4a21-8bf0-58af6e58a21d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Butler Community College Service Center",
      "poi_type": "Education",
      "poi_address": "2626 S Rock Rd #116, Wichita, KS 67210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.butlercc.edu/info/201029/campus-locations/466/wichita-service-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2138993657207693331&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "butler-community-college-service-center",
      "poi_latitude": "37.6449504",
      "poi_longitude": "-97.2438717",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 316-323-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzRqjAD77uocRE6Ct-mU7rx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dc21327d-3d99-48ed-a72d-cd45fa68ccba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Maize South High School",
      "poi_type": "Education",
      "poi_address": "3701 N Tyler Rd, Wichita, KS 67205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-bce8-718d-87e6-9eeb75bb1043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bce8-718d-87e6-9eeb75bb1043",
        "storage_key": "property/6767906449166551/019d7915-bce8-718d-87e6-9eeb75bb1043.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.usd266.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=644322955948170961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maize-south-high-school",
      "poi_latitude": "37.7496186",
      "poi_longitude": "-97.4487841",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-462-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuUl39AUgu4cR0Z7rjVAY8Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_281dc985-078e-45c7-87cd-add3032cfce0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Maize Middle School",
      "poi_type": "Education",
      "poi_address": "4600 N Maize Rd, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-bcb8-761f-92ba-bd2610e6abb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bcb8-761f-92ba-bd2610e6abb5",
        "storage_key": "property/6767906449166551/019d7915-bcb8-761f-92ba-bd2610e6abb5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.usd266.com/mms",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313195941021601572&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maize-middle-school",
      "poi_latitude": "37.7672283",
      "poi_longitude": "-97.4613267",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-729-2464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc2a1kEAgu4cRJM932HMfGiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6f82e163-2493-4f42-b49c-6f77efe9e4b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Maize South Elementary School",
      "poi_type": "Education",
      "poi_address": "3404 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.usd266.com/mse",
      "poi_directions_map_url": "https://maps.google.com/?cid=15667799364589113353&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maize-south-elementary-school",
      "poi_latitude": "37.7473203",
      "poi_longitude": "-97.4562901",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-462-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZFRZ3Qgu4cRCdBssoI0b9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c6bc941b-ae29-4236-a169-3b6fda360ca4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Wichita State University West",
      "poi_type": "Education",
      "poi_address": "3801 N Walker Ave, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-bb93-7573-86f0-cf68fbd09b5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-bb93-7573-86f0-cf68fbd09b5e",
        "storage_key": "property/6767906449166551/019d7915-bb93-7573-86f0-cf68fbd09b5e.webp",
        "width": 1280,
        "height": 391
      },
      "poi_business_url": "http://www.wichita.edu/west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16440172385250156795&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-state-university-west",
      "poi_latitude": "37.75301109999999",
      "poi_longitude": "-97.4598742",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-978-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC5xYTQ0gu4cR-6AFPa45J-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_894c23c4-32ae-46ac-a8b7-dc7b527cfe4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "St. Francis of Assisi Catholic School",
      "poi_type": "Education",
      "poi_address": "853 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stfranciswichita.com/index.php/school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799891258123803907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-francis-of-assisi-catholic-school",
      "poi_latitude": "37.6971551",
      "poi_longitude": "-97.4388012",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-722-5171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrQ2sPSreuocRA920rJSiwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7c90787a-fd3a-4f55-9f8a-6b3a429ec69a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Complete High School Maize",
      "poi_type": "Education",
      "poi_address": "745 W Academy Ave, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.usd266.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=208798567748800562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "complete-high-school-maize",
      "poi_latitude": "37.7725614",
      "poi_longitude": "-97.4760603",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-722-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_fCaZlkgu4cRMhBH7DDN5QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_47e9be98-aa6e-4940-9590-275b91464be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-c5ea-711b-b0a6-8752bd0cc366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c5ea-711b-b0a6-8752bd0cc366",
        "storage_key": "property/6767906449166551/019d7915-c5ea-711b-b0a6-8752bd0cc366.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_de241640-2737-4a45-8496-b288bd71aaad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "WSU Tech - City Center",
      "poi_type": "Education",
      "poi_address": "301 S Grove St, Wichita, KS 67211, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-c40a-7341-9f05-8f82e6324eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c40a-7341-9f05-8f82e6324eaf",
        "storage_key": "property/6767906449166551/019d7915-c40a-7341-9f05-8f82e6324eaf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13397923867905285235&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wsu-tech-city-center",
      "poi_latitude": "37.6822022",
      "poi_longitude": "-97.3093214",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5896-74c8-a249-fea78a29ea0a",
        "storage_key": "property/6767906449166551/019cfb50-5896-74c8-a249-fea78a29ea0a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ1WB7p3juocRc9w4ysX87rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_6072ab9a-d968-4b2f-8715-501f18c60cd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Bella Luna Cafe West",
      "poi_type": "Restaurants",
      "poi_address": "2441 N Maize Rd Ste 2511, Wichita, KS 67205, USA",
      "poi_short_description": "One in a set of low-key Mediterranean restaurants also serving a few American standards.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious food, including spinach and salmon salad, chicken shawarma, and gumbo. They highlight the laid-back yet slightly upscale atmosphere, and the good value. They also like the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-ca5a-708d-845a-8e9c74abeca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ca5a-708d-845a-8e9c74abeca6",
        "storage_key": "property/6767906449166551/019d7915-ca5a-708d-845a-8e9c74abeca6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bellalunacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17528823113026117757&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bella-luna-cafe-west",
      "poi_latitude": "37.7297896",
      "poi_longitude": "-97.4632258",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-613-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7Iw4pPfuocRfSCU5r_jQvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_14588bdc-66e2-4e5c-aa5b-0932b7637217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Amorè Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2315 W 21st St N suite 101, Wichita, KS 67203, USA",
      "poi_short_description": "Laid-back eatery dishing up traditional Italian fare such as pizza, pasta, rolls, parmigiana and risotto.",
      "poi_long_description": "People say this Italian restaurant serves delicious lasagna, fried ravioli, and eggplant parmesan. They also highlight the generous portions, reasonable prices, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-cb4e-77c9-8cc1-c3007a40221e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cb4e-77c9-8cc1-c3007a40221e",
        "storage_key": "property/6767906449166551/019d7915-cb4e-77c9-8cc1-c3007a40221e.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.orderamoreitalian.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=15225751986500224577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amor-italian-restaurant",
      "poi_latitude": "37.722595",
      "poi_longitude": "-97.3686978",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-500-1222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ297YWkbhuocRQUaLIcO8TNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_83769a6b-6615-40e1-ac08-1892a1fa6217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Sabor Latin Bar & Grille",
      "poi_type": "Restaurants",
      "poi_address": "309 N Mead St, Wichita, KS 67202, USA",
      "poi_short_description": "Contemporary eatery serving up Latin American meat & seafood entrees, plus wine, beer & cocktails.",
      "poi_long_description": "People say this bar and grill offers delicious Latin American dishes, including paella, ceviche, and vegetarian options like arepas and pupusas. They highlight the flavorful food, generous portions, and the variety of options on the menu. They also like the friendly and attentive service, and the chill atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-cbad-737c-9c79-0f4b812e7591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cbad-737c-9c79-0f4b812e7591",
        "storage_key": "property/6767906449166551/019d7915-cbad-737c-9c79-0f4b812e7591.webp",
        "width": 353,
        "height": 421
      },
      "poi_business_url": "https://empireks.com/restaurant/sabor-latin-bar-grille/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10634252004935429153&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sabor-latin-bar-grille",
      "poi_latitude": "37.6901452",
      "poi_longitude": "-97.3297982",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-201-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1e25-72f1-b9ae-fe49d3770afd",
        "storage_key": "property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cufdb_juocRIWwpFttzlJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_212650ea-03d1-47bc-b97e-dcd181036a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Doo-Dah Diner",
      "poi_type": "Restaurants",
      "poi_address": "206 E Kellogg St, Wichita, KS 67202, USA",
      "poi_short_description": "Homey diner serving from-scratch American breakfast & lunch classics, from pancakes to burgers.",
      "poi_long_description": "People say this diner serves delicious banana bread French toast, biscuits and gravy, and monkey bread. They highlight the generous portions, homemade food, and fun, cozy vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-d449-77be-9c88-2108808e5984.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d449-77be-9c88-2108808e5984",
        "storage_key": "property/6767906449166551/019d7915-d449-77be-9c88-2108808e5984.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://doodahdiner.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690445211555488726&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "doo-dah-diner",
      "poi_latitude": "37.6796006",
      "poi_longitude": "-97.3364484",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13z0ke7juocR1mNS3K6EHbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_96586698-1a3f-4941-90a4-c2086d73601c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Bite Me BBQ",
      "poi_type": "Restaurants",
      "poi_address": "132 St Francis, Wichita, KS 67202, USA",
      "poi_short_description": "Family-run BBQ joint serving brisket, pulled pork, ribs & all the trimmings in a down-home setting.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and pulled pork. They highlight the generous portions, reasonable prices, and the fun, lively atmosphere. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-d397-744a-a178-8d8410848cbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d397-744a-a178-8d8410848cbb",
        "storage_key": "property/6767906449166551/019d7915-d397-744a-a178-8d8410848cbb.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://biteme-bbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9339942062092147242&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bite-me-bbq",
      "poi_latitude": "37.6871145",
      "poi_longitude": "-97.3312857",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 316-729-2904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZaZIMDjuocRKlq7AdIjnoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_57901e17-e43a-45dc-b716-5430ba7b8492",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6707 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves perfectly seasoned steaks and phenomenal food. They highlight the fun environment and the attentive service. They also like the detailed service provided by the bartenders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-d7cf-7199-a111-c262188549e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d7cf-7199-a111-c262188549e1",
        "storage_key": "property/6767906449166551/019d7915-d7cf-7199-a111-c262188549e1.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-west-kellogg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790040154516989602&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.6720244",
      "poi_longitude": "-97.4200102",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-943-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_Fxv7nguocRoqYvOlrsvZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f85d7c78-938f-40cf-8f16-9046c1c81a2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Kobe Steak House of Japan",
      "poi_type": "Restaurants",
      "poi_address": "8760 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Stylish local Japanese steakhouse chain serving surf 'n' turf grilled tableside & cocktails.",
      "poi_long_description": "People say this Japanese restaurant offers delicious steak, fried rice, and chicken, and the chefs provide entertaining hibachi performances. They highlight the fun and welcoming atmosphere, and the attentive service. They also like the generous portions and the option to take food home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-edd4-772a-9f81-0b43ffc712a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-edd4-772a-9f81-0b43ffc712a9",
        "storage_key": "property/6767906449166551/019d7915-edd4-772a-9f81-0b43ffc712a9.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.kobewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12227000956179860781&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kobe-steak-house-of-japan",
      "poi_latitude": "37.7236958",
      "poi_longitude": "-97.4440675",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-558-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_k37JTfuocRLU12lZYIr6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_0c61b3b9-f7ae-42ef-8153-b9ac2dacbfe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Whiskey Dicks",
      "poi_type": "Restaurants",
      "poi_address": "801 S Seneca St, Wichita, KS 67213, USA",
      "poi_short_description": "Specializing in whiskey & burgers, this sports pub with a patio offers pool, darts & video golf.",
      "poi_long_description": "People say this bar and grill serves great burgers, wings, and a variety of appetizers, and offers a wide selection of whiskeys and cocktails. They highlight the affordable prices, especially during happy hour, and the laid-back, neighborhood bar vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-df0d-70be-888e-3643c894b04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-df0d-70be-888e-3643c894b04a",
        "storage_key": "property/6767906449166551/019d7915-df0d-70be-888e-3643c894b04a.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.whiskeydicksict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7997562356718223273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whiskey-dicks",
      "poi_latitude": "37.6751855",
      "poi_longitude": "-97.3532334",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 316-201-6209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1e25-72f1-b9ae-fe49d3770afd",
        "storage_key": "property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUA9ilfhuocRqb85LZcM_W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_e87796e0-ff69-436c-83ec-2d34cd3b909b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "River City Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "2277 Eisenhower Airport Pkwy, Wichita, KS 67209, USA",
      "poi_short_description": "Laid-back airport spot for pub grub, craft beer and cocktails, with live music on occasion.",
      "poi_long_description": "People say this brewpub offers delicious chicken fingers, pretzels, and pies, and the portions are generous.\n\nOther reviews mention the service can be slow and the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-e66d-70c8-a0e3-93670e845991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e66d-70c8-a0e3-93670e845991",
        "storage_key": "property/6767906449166551/019d7915-e66d-70c8-a0e3-93670e845991.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://rivercitybrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4726437560330887147&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-city-brewing-co",
      "poi_latitude": "37.6532674",
      "poi_longitude": "-97.430482",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-946-1801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1e25-72f1-b9ae-fe49d3770afd",
        "storage_key": "property/6767906449166551/019d7916-1e25-72f1-b9ae-fe49d3770afd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-qdElHnuocR6x-WXOutl0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_615ef9d6-157f-491c-ad40-a54361072732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Larkspur | Bistro & Bar",
      "poi_type": "Restaurants",
      "poi_address": "904 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "American bistro classics are served amid homey surrounds with a garden patio & a laid-back vibe.",
      "poi_long_description": "People say this bistro offers a nice variety of dishes, including salmon nicoise salad, filet, and pistachio chicken. They also highlight the welcoming and chill atmosphere, and the attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-ee4e-70e4-88c4-e8e827cd3958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ee4e-70e4-88c4-e8e827cd3958",
        "storage_key": "property/6767906449166551/019d7915-ee4e-70e4-88c4-e8e827cd3958.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.larkspuronline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3564099133631079210&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "larkspur-bistro-bar",
      "poi_latitude": "37.6863684",
      "poi_longitude": "-97.3273117",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-262-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b77-f824aa629a0c",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b77-f824aa629a0c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUnsnZXjuocRKqNbVEc5djE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_130fec05-983e-4872-9c39-0fde8c4fa8fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2727 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of home decor, home goods, and other items. They also highlight the clean and welcoming atmosphere, and the helpful and knowledgeable staff.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-f3fb-75fb-8b59-fdb2e22280a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f3fb-75fb-8b59-fdb2e22280a7",
        "storage_key": "property/6767906449166551/019d7915-f3fb-75fb-8b59-fdb2e22280a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/wichita-nw/1945",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507742534039652228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.7325155",
      "poi_longitude": "-97.4653923",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-721-4289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnfZzhI3fuocRhEeyjCkA05E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ca982832-895f-4967-8fd5-7c38fa7547f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Woodard Mercantile West in Maize",
      "poi_type": "Shopping & Retail",
      "poi_address": "4160 N Maize Rd, Maize, KS 67101, USA",
      "poi_short_description": "Family-run retailer of farm supplies, including hay and dog food, plus lawn and garden items.",
      "poi_long_description": "People say this feed store offers a wide variety of pet, animal, and gift merchandise, including seedlings, metal statues, and YETI products. They highlight the fun and unique items, and the friendly, relaxed atmosphere. They also like the helpful and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-f6d1-738d-920c-bce5ff874df4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f6d1-738d-920c-bce5ff874df4",
        "storage_key": "property/6767906449166551/019d7915-f6d1-738d-920c-bce5ff874df4.webp",
        "width": 838,
        "height": 420
      },
      "poi_business_url": "https://www.woodardmercantile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3494977488004901784&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodard-mercantile-west-in-maize",
      "poi_latitude": "37.7586314",
      "poi_longitude": "-97.462187",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-722-0216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsd5bm2sgu4cRmOuEFoKngDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_83739002-1b6c-4a4e-b8fb-5d6197884ba8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Pride Ag Resources Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "5204 N Maize Rd, Maize, KS 67101, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "People say this hardware store offers a wide selection of tools, hardware, and supplies, including Milwaukee brand products and Meat Church seasonings. They highlight the reasonable prices and high-quality items. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7915-fb0d-75cb-af70-07cd44859b41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fb0d-75cb-af70-07cd44859b41",
        "storage_key": "property/6767906449166551/019d7915-fb0d-75cb-af70-07cd44859b41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.prideagace.com/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=15368",
      "poi_directions_map_url": "https://maps.google.com/?cid=18074077085130896819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pride-ag-resources-ace-hardware",
      "poi_latitude": "37.7783284",
      "poi_longitude": "-97.4625049",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-722-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaSSJdUkgu4cRszVBLlkF1Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_71ca4615-4270-4fc4-90c9-ffe3076e585c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Maize Athletic Department",
      "poi_type": "Shopping & Retail",
      "poi_address": "11600 W 45th St N, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451557052431471503&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "maize-athletic-department",
      "poi_latitude": "37.7687624",
      "poi_longitude": "-97.4763852",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-729-4191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_fCaZlkgu4cRjxP0bkHSp0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_600b874b-d726-4e92-b794-79344a7f4ed0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2764 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-006b-719c-aa04-ee34e20ef613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-006b-719c-aa04-ee34e20ef613",
        "storage_key": "property/6767906449166551/019d7916-006b-719c-aa04-ee34e20ef613.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14574096873675231472&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "37.7331453",
      "poi_longitude": "-97.4603356",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-773-2641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLYZhKVnfuocR8BCLxeOXQco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_c5251159-9886-4d9c-9a51-372752f60c97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "New Market Square, 2441 N Maize Rd Ste 2201, Wichita, KS 67205, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-0185-73c9-8bb2-94f2968bdc64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0185-73c9-8bb2-94f2968bdc64",
        "storage_key": "property/6767906449166551/019d7916-0185-73c9-8bb2-94f2968bdc64.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/KS/Wichita/9179/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10470215157974359630&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "37.7303448",
      "poi_longitude": "-97.4649292",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-722-3472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-58a1-7298-b24b-337a83eb9a51",
        "storage_key": "property/6767906449166551/019cfb50-58a1-7298-b24b-337a83eb9a51.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP7Iw4pPfuocRTt74bDatTZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_cdc76ff9-8fb3-4f14-87f7-a1beefaabfb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Chamber Music At The Barn at Prairie Pines",
      "poi_type": "Entertainment",
      "poi_address": "4055 N Tyler Rd, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-0208-76e5-bf35-507dad62554b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0208-76e5-bf35-507dad62554b",
        "storage_key": "property/6767906449166551/019d7916-0208-76e5-bf35-507dad62554b.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16303649399625961344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chamber-music-at-the-barn-at-prairie-pines",
      "poi_latitude": "37.7575609",
      "poi_longitude": "-97.4477132",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-721-7666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0UDmW0gu4cRgE83n78yQuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_86d93884-f800-4310-b9c6-5eacfc843c03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Kansas International Dragway",
      "poi_type": "Entertainment",
      "poi_address": "7800 W 61st St N, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-0761-7340-88df-5fab9642d499.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0761-7340-88df-5fab9642d499",
        "storage_key": "property/6767906449166551/019d7916-0761-7340-88df-5fab9642d499.webp",
        "width": 1280,
        "height": 467
      },
      "poi_business_url": "http://www.ksinternationaldragway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8789649995291270170&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kansas-international-dragway",
      "poi_latitude": "37.7967491",
      "poi_longitude": "-97.4369964",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 316-680-1038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0g1_dchu4cRGpxZ5Rkc-3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_26b8e3e8-3329-4755-84bf-cc6935af2f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "C-Arrow Stables",
      "poi_type": "Entertainment",
      "poi_address": "5911 N Maize Rd, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-097f-76cf-92eb-0a803be38d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-097f-76cf-92eb-0a803be38d23",
        "storage_key": "property/6767906449166551/019d7916-097f-76cf-92eb-0a803be38d23.webp",
        "width": 1112,
        "height": 1280
      },
      "poi_business_url": "http://www.c-arrow-stables.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17668912577754396209&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "c-arrow-stables",
      "poi_latitude": "37.7925643",
      "poi_longitude": "-97.4638442",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-722-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERzRKLEhu4cRMXZ7JGCWNPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stable"
    },
    {
      "id": "custom_03a1109b-b36e-4dd3-afa3-f8dbb1be9850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Prime IV Hydration & Wellness - West Wichita",
      "poi_type": "Entertainment",
      "poi_address": "4041 N Maize Rd #210, Maize, KS 67101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-0ae1-7141-867b-74ddfb1cce4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0ae1-7141-867b-74ddfb1cce4a",
        "storage_key": "property/6767906449166551/019d7916-0ae1-7141-867b-74ddfb1cce4a.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://ivwichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5055664860974818542&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "prime-iv-hydration-wellness-west-wichita",
      "poi_latitude": "37.7570042",
      "poi_longitude": "-97.4637884",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-531-9057",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1I05Q0hu4cR7iTUrWdUKUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_aa43647c-8d4d-47c8-b138-effbfcbfe772",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Museum of World Treasures",
      "poi_type": "Entertainment",
      "poi_address": "835 E 1st St N, Wichita, KS 67202, USA",
      "poi_short_description": "A history-of-the-world museum with an educational focus & hands-on children's activity center.",
      "poi_long_description": "People say this museum offers a wide variety of exhibits, including dinosaurs, mummies, and artifacts from different time periods and cultures. They highlight the impressive collection, the educational experience, and the affordable prices. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-0aa1-7421-94ff-8efde07f9da1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0aa1-7421-94ff-8efde07f9da1",
        "storage_key": "property/6767906449166551/019d7916-0aa1-7421-94ff-8efde07f9da1.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://worldtreasures.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1404316722265454010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-world-treasures",
      "poi_latitude": "37.687089",
      "poi_longitude": "-97.327885",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1edb-728a-980e-d48dd2e3fc6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1edb-728a-980e-d48dd2e3fc6c",
        "storage_key": "property/6767906449166551/019d7916-1edb-728a-980e-d48dd2e3fc6c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz_xfJXjuocRuvXFVp4ifRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_909ecd7d-c5a6-4bc8-8c9a-1396a386d2f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Entertainment",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, a butterfly house, and a children's area with a carousel and playground. They highlight the tranquil and peaceful atmosphere, and the well-maintained grounds with labeled plants and artistic sculptures. They also like the fun and engaging activities for children, such as the splash area and treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1089-74b6-85b4-cc71beb59377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-1089-74b6-85b4-cc71beb59377",
        "storage_key": "property/6767906449166551/019d7916-1089-74b6-85b4-cc71beb59377.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_3aa6ec80-bd9e-438b-89d9-21079e8c8f11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Wichita Sports Forum",
      "poi_type": "Entertainment",
      "poi_address": "2668 N Greenwich Rd, Wichita, KS 67226, USA",
      "poi_short_description": "Trampoline area with several foam pits, plus sand volleyball, basketball and soccer courts.",
      "poi_long_description": "People say this sports complex offers a variety of activities, including basketball, volleyball, and a trampoline park. They also highlight the fun atmosphere and the friendly, helpful staff.\n\nSome reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-12a6-74a3-aa94-5b30e7e71cf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-12a6-74a3-aa94-5b30e7e71cf1",
        "storage_key": "property/6767906449166551/019d7916-12a6-74a3-aa94-5b30e7e71cf1.webp",
        "width": 1280,
        "height": 457
      },
      "poi_business_url": "http://wichitasportsforum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=290413582065142880&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-sports-forum",
      "poi_latitude": "37.7324621",
      "poi_longitude": "-97.1999983",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 316-201-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-5895-7113-8b78-03961667910b",
        "storage_key": "property/6767906449166551/019cfb50-5895-7113-8b78-03961667910b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bsAl7v9uocRYAzxPJ3BBwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_64a1a4f7-ed54-4c6a-a4b6-22364e9bd71f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Old Cowtown Museum",
      "poi_type": "Entertainment",
      "poi_address": "1865 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Re-creation of late-1880s life in the County, including farm animals, photos & document archives.",
      "poi_long_description": "People say this museum offers a fun and educational experience with live demonstrations, interactive exhibits, and a glimpse into the past. They highlight the self-paced tours, the opportunity to explore historic buildings, and the entertaining gunfights and shows. They also like the knowledgeable and friendly staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-14ae-7128-b870-9b7e5e6dfa43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-14ae-7128-b870-9b7e5e6dfa43",
        "storage_key": "property/6767906449166551/019d7916-14ae-7128-b870-9b7e5e6dfa43.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.oldcowtown.org/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13259083149142063349&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-cowtown-museum",
      "poi_latitude": "37.6936698",
      "poi_longitude": "-97.3601599",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 316-350-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019d7916-1edb-728a-980e-d48dd2e3fc6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-1edb-728a-980e-d48dd2e3fc6c",
        "storage_key": "property/6767906449166551/019d7916-1edb-728a-980e-d48dd2e3fc6c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYk8gGThuocR9fj639-5Abg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b310ddae-2db9-4c4c-ae1a-a3b75969710b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Cafe Bel Ami",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "cafe-bel-ami",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a79f1946-be30-47b8-bcbb-04e3922fdc0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Etcetera Etcetera",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "etcetera-etcetera",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_104583d3-df3e-4842-898a-518c3aed5e3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "poi_name": "Warren West 17 & IMAX",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "warren-west-17-imax",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a09d011e2305a5f591266b2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2469c26fb1ae3480e2630c5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_17248cc51b7079f30b781b57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_93efa61d7221327ded976d90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_d20ee428d7252c1504fb0dbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_b5dc48686a30e60d46b066ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_280f4681-0669-4a99-9a13-897369d5c078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "rating": "5.0",
      "name": "Janet Greene",
      "text": "From beginning to end, Evelyn guided us through the apartment application and selection process. She was there whenever we needed her to answer every question. We can't imagine a smoother rental experience. Our apartment is spacious, clean and attractive. We are very happy!",
      "date": "2025-10-10",
      "title": ""
    },
    {
      "id": "custom_1296e38e-8151-47d7-bcaf-7a489e08d425",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "rating": "5.0",
      "name": "dawn pratt",
      "text": "Both areas of my bathtub were addressed and handled in a very timely manner.  I appreciate that old parts were replaced and the tub looks great. I’ve always been very impressed with Watercress maintenance.",
      "date": "2025-10-11",
      "title": ""
    },
    {
      "id": "custom_c6358b6d-4c38-49f4-b4ee-0320101f29b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "rating": "5.0",
      "name": "Susan Blake",
      "text": "Wonderful complex, I enjoy living here. The apartment and patio are very much to my liking however, landscaping and lawn care are lacking. Outdoor Sprinkler System was broken all summer, lawn never watered, lots of weeds and bare spots. Shrubs die and are not replaced. Short on help so weeds grow rapidly especially where shrubs have died. Complex is pet friendly, no restrictions. Some owners don’t pick up their dog’s waste. The pool area is clean and modern except for when residents invite their extended family to party.\nAll in all, I don’t plan on moving.",
      "date": "2025-09-25",
      "title": ""
    },
    {
      "id": "custom_680f57e0-e9c7-41c3-8336-a68c6cc93e1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "rating": "5.0",
      "name": "Holly Wood",
      "text": "I toured Watercress in November 2024 and was obsessed w/wanting to live here. My lease wasn't up until April 2025 at my old apt, but I applied to move to Watercress in January and the girls found me the PERFECT apartment. They've been great to work with. I wanted ground floor, south facing, 2 bed 2 bath w/fireplace, and that is what I got. It's nice to have tiled showers and tile floor. The layout is like a little house and the maintenance team has been very nice.\n\nThe most noise you hear are the people who stomp on the stairs or use their carts to drag things down (you have those who get it and are considerate and those who don't care-but you can't control that, that's apartment living) and occasionally I hear the footsteps and dog steps above me, but no TVs, radio's or conversations which is really nice.\n\nLandscaping throughout the complex is GORGEOUS, I am so impressed with how nice it is. I will say the Northeast corners could use a little more love as it looks like they ran out of bushes and shrubs to finish some of those areas out, but overall such a beautiful complex. They also let you plant your own flowers/plants if you would like :) Whomever takes care of the grounds are great. They constantly take out dead bushes and trees (can't believe other reviews have complained about this). I also see them always trying to grow new grass in bare spots.\n\nThe pool is very well maintained and so is the dog park (I know some reviews in the past weren't happy with the dog park but they must have changed it) I will say some people don't care that one area is for SMALL dogs and the other is for LARGE dogs, so some days I have to skip taking my small dog out because he's scared of larger dogs :( But we've made some nice new friends w/pets in the first couple of months which is nice. The fountains are so peaceful, it's just a nice place to walk around and enjoy and feel very safe at. Highly recommend.",
      "date": "2025-09-30",
      "title": ""
    },
    {
      "id": "custom_da59ba1a-3ee3-4ea4-938b-37f0bc84b03a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "rating": "5.0",
      "name": "Abby Christensen",
      "text": "We haven't lived here long, but Evelyn made the leasing process so simple! Our apartment is spacious and the whole property is beautiful. We especially love the pool area!",
      "date": "2025-08-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c3a7fb4b-546a-4efd-a50c-027b8a0f8874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-b0c2-7139-a7c0-5934d69730ba.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb50-b0c2-7139-a7c0-5934d69730ba",
        "storage_key": "property/6767906449166551/019cfb50-b0c2-7139-a7c0-5934d69730ba.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Watercress Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f44d5a1601bdb1ec052f32d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b5-d9bf-752f-89f2-9e94920ef5cb",
      "lead_source": "LANDING_PAGE",
      "name": "case-watercress-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551"
    },
    {
      "lead_collector_id": "019cf79d-44e0-751c-acb6-2727a3d74203",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "watercress-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-maize-ks",
      "search_query": "apartments with in-unit laundry Maize KS",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry in Maize, KS. Enjoy modern living at its finest with our convenient amenities at Watercress.",
      "page_copy": "Welcome to Watercress, where modern living meets convenience in Maize, KS. Our apartments with in-unit laundry provide the perfect blend of comfort and practicality, making chores a breeze. Choose from our spacious one, two, or three-bedroom layouts, each designed to enhance your lifestyle. \n\nAt Watercress, you're more than just a resident, you're part of a vibrant community. Beyond the convenience of in-unit laundry, enjoy our fully-equipped fitness center, sparkling pool, and a playful dog park. Love where you live with engaging social events and beautiful outdoor areas, all nestled in the vibrant community of Northwest Wichita, Sedgwick County. Welcome home to Watercress!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry | Maize, KS",
      "seo_description": "Find apartments with in-unit laundry in Maize, KS at Watercress. Elevate your lifestyle with modern amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-northwest-wichita",
      "search_query": "air conditioned apartments Northwest Wichita",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Wichita",
      "h2_subtitle": "Experience air conditioned comfort in Northwest Wichita. Discover the perfect home at Watercress with modern amenities and inviting spaces.",
      "page_copy": "Nestled in the charming neighborhood of Northwest Wichita, Watercress offers air conditioned apartments that promise a cool and comfortable living experience. Whether you're seeking a one, two, or three-bedroom layout, each residence is thoughtfully designed for modern convenience and relaxation.\n\nBeyond air conditioned comfort, Watercress provides an array of amenities that enhance your lifestyle. Unwind by the sparkling pool, stay active in our fitness center, or enjoy the outdoors with a scenic view. Our community in Maize, KS, fosters a welcoming atmosphere with engaging activities and ample green spaces. Discover your ideal home at Watercress, where comfort meets community in Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments | Wichita, KS",
      "seo_description": "Find air conditioned apartments in Northwest Wichita at Watercress. Discover modern comfort with a host of amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-dedicated-parking-sedgwick-county",
      "search_query": "apartments with dedicated parking Sedgwick County",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking",
      "h2_subtitle": "Find apartments with dedicated parking in Sedgwick County. Watercress offers convenience and modern living in Maize, KS.",
      "page_copy": "At Watercress in Maize, KS, enjoy the ease of having dedicated parking as part of your living experience. Conveniently located in Sedgwick County, our community provides more than just a place to park—it's a home where your needs are met. Choose from spacious floor plans, including one, two, or three-bedroom apartments, designed to provide the ultimate in comfort.\n\nLiving at Watercress comes with access to a wealth of amenities beyond just dedicated parking. Residents appreciate the community feel, engaging social events, and amenities such as a sparkling pool, intercom system, and fully-equipped fitness center. Positioned in Northwest Wichita, Watercress combines practicality with style, ensuring a superb living experience for all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Parking | Sedgwick County, KS",
      "seo_description": "Discover apartments with dedicated parking in Sedgwick County at Watercress. Enjoy convenience and modern amenities in a vibrant Maize community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "spacious-apartments-dishwashers-near-67101",
      "search_query": "spacious apartments with dishwashers near 67101",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Dishwashers",
      "h2_subtitle": "Explore spacious apartments with dishwashers near 67101. Watercress offers modern amenities and comfortable living in Maize, KS.",
      "page_copy": "Experience the perfect blend of space and convenience at Watercress, located near 67101 in Maize, KS. Our spacious apartments, equipped with dishwashers, cater to a contemporary lifestyle with the comforts you desire. Choose from various floor plans, including one, two, and three-bedroom options, all designed to maximize living areas.\n\nSituated in the vibrant Northwest Wichita area, residents at Watercress enjoy a wealth of amenities that enhance daily living. From the sparkling pool to a modern fitness center and community events, there's something for everyone. Join a friendly neighborhood in Sedgwick County, where spacious living and community charm make every day a delight.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Dishwashers | Maize, KS",
      "seo_description": "Find spacious apartments with dishwashers near 67101 at Watercress. Enjoy modern amenities and a vibrant community in Maize, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-with-pool-maize-ks",
      "search_query": "apartments with a pool in Maize KS",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Maize, KS",
      "h2_subtitle": "Enjoy apartments with a pool in Maize, KS. Watercress offers a refreshing escape and a vibrant community with modern amenities.",
      "page_copy": "Watercress, located in the heart of Maize, KS, offers apartments with a stunning pool that provides a perfect oasis for residents. Dive into relaxation and take advantage of the well-maintained pool, ideal for both leisure and exercise. Our community is thoughtfully designed to meet your lifestyle needs with spacious one, two, and three-bedroom options available.\n\nBeyond the pool, Watercress provides a full range of amenities, including a fitness center and beautiful outdoor spaces. Engage in community activities and enjoy the charming Northwest Wichita neighborhood setting. At Watercress, residents experience convenience and a fulfilling lifestyle, making it the perfect place to call home in Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool | Maize, KS",
      "seo_description": "Discover apartments with a pool in Maize, KS at Watercress. Enjoy modern living with a range of amenities in a vibrant Sedgwick County community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-maize-ks",
      "search_query": "one bedroom apartments maize ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Maize, KS",
      "h2_subtitle": "Discover one bedroom apartments in Maize, KS. Watercress offers comfortable living with modern amenities and a welcoming community atmosphere.",
      "page_copy": "At Watercress, we offer beautifully designed one bedroom apartments in Maize, KS, tailored for those who seek comfort and style. Located in Sedgwick County, our community combines modern living with convenience, providing the perfect environment for relaxation and enjoyment. Each one bedroom apartment features an open layout and modern kitchen amenities that make day-to-day living a breeze.\n\nBeyond the comfort of your own apartment, Watercress offers a host of community features such as a sparkling pool, fitness center, and dynamic social activities. Nestled in the vibrant Northwest Wichita area, you're not just finding a home, but also a community where you can thrive. Explore the possibilities at Watercress today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Maize, KS",
      "seo_description": "Find cozy one bedroom apartments in Maize, KS at Watercress. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-northwest-wichita",
      "search_query": "two bedroom floor plans northwest wichita",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Northwest Wichita",
      "h2_subtitle": "Explore two bedroom floor plans in Northwest Wichita. Watercress offers spacious layouts and modern amenities in a vibrant community setting.",
      "page_copy": "Watercress presents exceptional two bedroom floor plans in the charming Northwest Wichita area, designed to offer spacious living with modern conveniences. Each apartment is crafted with thoughtful attention to detail, providing open living spaces and contemporary features such as an island kitchen, perfect for both entertaining and everyday relaxation.\n\nLocated in Maize, KS, Watercress offers more than just a place to live. Join a community enriched with amenities like a sparkling pool, fitness center, and engaging social activities. Whether you are looking to upsize or find a comfortable home, our two bedroom floor plans cater to a wide range of lifestyle needs, providing the perfect blend of comfort and style in Sedgwick County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans | Northwest Wichita",
      "seo_description": "Discover spacious two bedroom floor plans in Northwest Wichita at Watercress. Enjoy modern amenities in a vibrant Sedgwick County community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-sedgwick-county",
      "search_query": "three bedroom apartments sedgwick county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Sedgwick County",
      "h2_subtitle": "Find three bedroom apartments in Sedgwick County. Watercress offers spacious living with modern amenities and a vibrant community atmosphere.",
      "page_copy": "Discover the comfort of three bedroom apartments at Watercress, located in the heart of Sedgwick County. Offering generous space and modern designs, these apartments provide the perfect setting for families or those needing extra room. Features such as an island kitchen and open floor plan create a welcoming environment ideal for both entertainment and daily living.\n\nLocated in Maize, KS, Watercress not only offers a place to live but also a community to thrive in. Enjoy amenities like a refreshing pool, fitness center, and regular community events that enhance your living experience. Embrace the perfect blend of style and convenience in Northwest Wichita as part of the Watercress community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments | Sedgwick County",
      "seo_description": "Explore spacious three bedroom apartments in Sedgwick County at Watercress. Enjoy modern living in a vibrant community with ample amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-via-christi-st-teresa",
      "search_query": "apartments near Ascension Via Christi St. Teresa Wichita KS",
      "category": "Hospital",
      "h1_title": "Apartments Near Ascension Via Christi St. Teresa",
      "h2_subtitle": "Find convenient apartments near Ascension Via Christi St. Teresa in Wichita, KS. Watercress offers modern living just a short drive away.",
      "page_copy": "If you're seeking convenient living in proximity to Ascension Via Christi St. Teresa in Wichita, KS, Watercress is the perfect choice. Located in Maize, just a short drive from the hospital, our community offers a blend of modern amenities and comfortable living spaces. Choose from various floor plans, including one, two, and three bedroom apartments equipped with contemporary features and stylish designs.\n\nResidents at Watercress enjoy more than just a home; our vibrant community features a sparkling pool, fitness center, and dog park, making it ideal for all lifestyles. Enjoy the peace of mind that comes with being close to essential services and a welcoming community atmosphere. Experience hassle-free, fulfilling living at Watercress today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ascension Via Christi St. Teresa",
      "seo_description": "Find modern apartments near Ascension Via Christi St. Teresa in Wichita, KS at Watercress, offering easy access and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "rentals-close-to-hylo-urgent-care-maize",
      "search_query": "rentals close to Hylo Urgent Care Maize Sedgwick County",
      "category": "Hospital",
      "h1_title": "Rentals Near Hylo Urgent Care in Maize",
      "h2_subtitle": "Discover rentals close to Hylo Urgent Care in Maize, right in the heart of Sedgwick County. Watercress offers a comfortable and convenient living option.",
      "page_copy": "Watercress offers ideal rentals close to Hylo Urgent Care in Maize, situated perfectly within Sedgwick County. Our beautifully designed apartment homes cater to those seeking convenience and accessibility to essential services. With options like one, two, and three bedroom layouts, each apartment is thoughtfully equipped with modern amenities to enhance your lifestyle, including spacious island kitchens and scenic views.\n\nAt Watercress, enjoy a vibrant community atmosphere with excellent facilities like a refreshing pool, a well-equipped fitness center, and a multi-use room for social activities. Whether you are looking for comfortable convenience or seamless access to essential care, our rentals offer the perfect blend of both just minutes from Hylo Urgent Care.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Hylo Urgent Care in Maize",
      "seo_description": "Explore comfortable rentals near Hylo Urgent Care in Maize. Watercress offers modern living close to essential amenities in Sedgwick County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-near-sedgwick-county-park",
      "search_query": "apartments near Sedgwick County Park KS",
      "category": "Park",
      "h1_title": "Apartments Near Sedgwick County Park",
      "h2_subtitle": "Explore apartments near Sedgwick County Park, KS. Watercress offers modern living in a prime location with accessible outdoor recreation.",
      "page_copy": "Watercress offers fantastic apartments near Sedgwick County Park, KS, perfectly blending access to outdoor recreation with modern living. Located in Maize, these one, two, and three bedroom apartments provide a great base for enjoying the park's natural beauty and amenities. Enjoy features like an island kitchen, ample living space, and quality finishes that make daily living a breeze.\n\nLiving at Watercress also means access to a host of on-site amenities, including a refreshing pool, fitness center, and fenced lot providing peace of mind. Join an engaging community that hosts regular social activities, or unwind with the stunning views right from your home. Experience the convenience and charm of life near Sedgwick County Park with Watercress.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sedgwick County Park, KS",
      "seo_description": "Find modern apartments near Sedgwick County Park, KS. Enjoy outdoor access and comfortable living at Watercress in Maize.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "apartments-close-to-swanson-park-nw-wichita",
      "search_query": "apartments close to Swanson Park Northwest Wichita",
      "category": "Park",
      "h1_title": "Apartments Close to Swanson Park",
      "h2_subtitle": "Find perfect apartments close to Swanson Park in Northwest Wichita. Watercress offers a modern living experience with park access.",
      "page_copy": "Discover comfortable living at Watercress, with apartments close to Swanson Park in Northwest Wichita. This serene location provides easy access to lush green spaces while offering the contemporary amenities you desire. Choose from spacious one, two, and three bedroom floor plans that are designed to suit your lifestyle needs.\n\nAt Watercress, residents enjoy a range of community features, such as a refreshing pool and a fully-equipped fitness center, perfect for relaxation and staying active. With convenient access to Swanson Park, outdoor adventures and peaceful walks are just steps away. Embrace a balanced life where convenience meets tranquility right here in Northwest Wichita.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Swanson Park, Wichita",
      "seo_description": "Discover modern apartments near Swanson Park in Northwest Wichita. Enjoy easy park access and a vibrant lifestyle at Watercress.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166551",
      "source": "generator",
      "page_item_url": "watercress-apartments-by-buffalo-park",
      "search_query": "Watercress apartments by Buffalo Park Sedgwick County",
      "category": "Park",
      "h1_title": "Watercress Apartments by Buffalo Park",
      "h2_subtitle": "Find Watercress apartments conveniently located by Buffalo Park in Sedgwick County. Enjoy vibrant living and outdoor adventures.",
      "page_copy": "Discover the appeal of living at Watercress apartments, ideally situated near Buffalo Park in Sedgwick County. With our one, two, and three-bedroom options, you can enjoy a refined, modern lifestyle that combines the tranquility of nearby green spaces with the hustle and bustle of community activities. Each apartment features comfortable designs, including island kitchens and energy-efficient amenities.\n\nWatercress not only provides a perfect home but also offers a range of community-focused amenities like a sparkling pool and a multi-use room for gatherings. Being close to Buffalo Park means easy access to outdoor trails and recreational activities. Embrace the perfect balance of peaceful living in nature's embrace and community connection at Watercress.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
      "featured_image_media": {
        "alt_text": "Kitchen island with seating and sink.",
        "public_id": "019cfb50-351b-75d8-9b1f-010df1867b81",
        "storage_key": "property/6767906449166551/019cfb50-351b-75d8-9b1f-010df1867b81.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Watercress Apartments by Buffalo Park",
      "seo_description": "Explore Watercress apartments near Buffalo Park in Sedgwick County. Enjoy modern living with easy park access and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5231"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-ZGVSMT38JQ"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128853468"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/watercress/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5MRPZHZF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449166551/019d1bd6-2c69-73e3-b4d3-3778a78e25dc.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47176468377"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "2a30725c-1b12-4887-83ab-392af2b3b39f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-634-4154"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "650082aef9fcae48948faa44"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjcwaU9Qd0xaeTQzNTQrSlB0bEZPMEE9PSIsInZhbHVlIjoieFFVSGpOcjZzR3ZyUGp6QlgzeDhpZz09IiwibWFjIjoiMmU4NjVmNjgyYTZiNmQxMDI2NTQzODk2MjI1ZjZmMDgyMzEzYTMwNDA0ZTA1MTYzNjFlNDU0ZjBkZjUxNjk2ZSJ9"
    }
  ],
  "custom_qb_id": "5231",
  "custom_ga4_id": "G-ZGVSMT38JQ",
  "custom_repli_id": "18128853468",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/watercress/register/",
  "custom_google_gtm_id": "GTM-5MRPZHZF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449166551/019d1bd6-2c69-73e3-b4d3-3778a78e25dc.pdf",
  "custom_hubspot_company_id": "47176468377",
  "custom_rentgrata_property_id": "2a30725c-1b12-4887-83ab-392af2b3b39f",
  "custom_ppc_tracking_phone_number": "844-634-4154",
  "custom_residentboost_apartment_id": "650082aef9fcae48948faa44",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjcwaU9Qd0xaeTQzNTQrSlB0bEZPMEE9PSIsInZhbHVlIjoieFFVSGpOcjZzR3ZyUGp6QlgzeDhpZz09IiwibWFjIjoiMmU4NjVmNjgyYTZiNmQxMDI2NTQzODk2MjI1ZjZmMDgyMzEzYTMwNDA0ZTA1MTYzNjFlNDU0ZjBkZjUxNjk2ZSJ9"
};

export const generatedAt = '2026-08-27T21:34:03.407Z';
